<template>
  <div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="tncModal"
      id="tncModal"
      hide-header
      hide-footer
      class="country-modal"
    >
      <div v-if="ratingContent && ratingContent.title" class="modal-title">
        <h4>{{ ratingContent.title }}</h4>
      </div>
      <div v-if="ratingContent" class="d-flex mx-2">
        <div v-if="ratingContent.image && false" class="col-3">
          <img :src="ratingContent.image" alt="rating_icon" />
        </div>
        <div class="col-12">
          <p v-if="ratingContent && ratingContent.content">
            <span v-html="ratingContent.content"></span>
          </p>
        </div>
      </div>

      <div v-if="ratingContent" class="row mx-0 py-3">
        <div class="col-6">
          <button
            type="button"
            v-on:click="onCancelRedirectBack()"
            class="btn-confirm active"
          >
            {{ $t("Cancel") }}
          </button>
        </div>
        <div class="col-6">
          <button
            type="button"
            v-on:click="onClickSeatSelectionModal()"
            class="btn-confirm active"
          >
            {{ $t("Accept") }}
          </button>
        </div>
      </div>
    </b-modal>
    <div class="select-seat-modal">
      <!-- <b-button v-b-modal.seat_select_modal>Select Seat</b-button> -->
      <b-modal
        hide-footer
        hide-header
        no-close-on-esc
        no-close-on-backdrop
        ref="seat_select_modal"
        id="seat_select_modal"
        class="seat_select_modal"
      >
        <div class="seats_num py-2 text-center">
          <h5>
            {{ $t("SELECT_NO_OF_SEAT") }}
          </h5>
          <div class="my-4">
            <div v-for="(data, index) in 6" :key="index">
              <!-- <img src="@/assets/img/seats/1Seats.png" class="about_img"/> -->
              <div v-if="totalNumberOfSeats == index + 1">
                <img
                  :src="
                    require('@/assets/img/seats/' + (index + 1) + 'Seats.png')
                  "
                  alt=""
                  class="numbers-seats-img"
                />
              </div>
            </div>
          </div>
          <ul
            class="seatNumList list-inline pl-0 mb-0"
            :class="isRTL ? 'number_reverse' : ''"
          >
            <li
              class="list-inline-item seat_btn"
              v-for="(item, itemKey) in 6"
              :key="itemKey"
              :class="
                totalNumberOfSeats == item ? 'seat_btn_active active' : ''
              "
              @click="onShowSeatImg(item)"
            >
              {{ itemKey + 1 }}
            </li>
          </ul>

          <div v-if="OnlySeatType.length > 0" class="my-4">
            <!-- <h6 class="mb-3">Select the seat type</h6> -->
            <div class="row justify-content-center">
              <div
                v-for="(SingleSeatType, SeatKey) in OnlySeatType"
                :key="SeatKey"
                :class="
                  OnlySeatType.length == 1 ? 'col-6' : 'col-' + seatsClass
                "
              >
                <div
                  v-on:click="onNewSelectSeatType(SingleSeatType)"
                  :class="
                    IsSeatTypePopup == true && SeatType.ID === SingleSeatType.ID
                      ? 'seat_btn seat_btn_type seat_btn_active seat-align'
                      : ''
                  "
                >
                  <input
                    class="sncheck-align"
                    type="checkbox"
                    :id="'index' + SeatKey"
                    v-if="IsSeatTypePopup == true"
                    :checked="
                      IsSeatTypePopup == true &&
                      SeatType.ID === SingleSeatType.ID
                        ? 'true'
                        : ''
                    "
                  />
                  <!-- {{ SingleSeatType.SeatType }} -->
                  <div v-if="cinemaDetails.CinemaID != 33">
                    <span v-if="SingleSeatType.SeatType == 'balcony'">
                      VIP
                    </span>
                    <span
                      v-else-if="
                        SingleSeatType.SeatType == 'orchestra' &&
                          cinemaDetails.CinemaID == '35'
                      "
                    >
                      VIP Gold (RECLINERS)
                    </span>
                    <span v-else-if="SingleSeatType.SeatType == 'orchestra'">
                      VIP Gold
                    </span>
                    <span
                      v-else-if="
                        SingleSeatType.SeatType == 'Standard' &&
                          SingleSeatType.screen_id == '65'
                      "
                    >
                      VIP DIAMOND (RECLINERS)
                    </span>
                    <span v-else-if="SingleSeatType.SeatType == 'Standard'">
                      STANDARD
                    </span>
                    <span v-else> {{ SingleSeatType.SeatType }} </span>
                  </div>
                  <div v-else>{{ SingleSeatType.SeatType }}</div>
                  ({{ Currency }} {{ SingleSeatType.Price }})
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              :disabled="
                IsSeatTypePopup == true && SelectedSeatType == '' ? true : false
              "
              class="btn btn-pink w-100"
              @click="onSelectNumberOfSeats(totalNumberOfSeats)"
            >
              SELECT SEATS
            </button>
          </div>
        </div>
      </b-modal>
    </div>

    <div class="select-seat-modal">
      <!-- <b-button v-b-modal.seat_select_modal>Select Seat</b-button> -->
      <b-modal
        hide-footer
        hide-header
        size="lg"
        no-close-on-esc
        no-close-on-backdrop
        ref="rated_modal"
        id="rated_modal"
        class="seat_select_modal"
      >
        <div class="seats_num py-lg-3 py-3 text-center">
          <h5 class="font-weight-bold">
            {{ $t("NOTE") }}
          </h5>

          <p>
            {{ $t("RATED_NOTE", { rated: movieDetails.rated || "" }) }}
          </p>

          <button
            v-on:click="hideRatedModal()"
            class="active btn-proceed-myticket mt-2"
          >
            {{ $t("PROCEED") }}
          </button>
        </div>
      </b-modal>
    </div>

    <div class="modal-bg" v-if="savedBankPage.src">
      <vue-friendly-iframe
        :src="savedBankPage.src"
        v-if="savedBankPage.src"
        class="text-center"
      ></vue-friendly-iframe>
    </div>
    <div class="modal-bg" v-if="bankPage.src">
      <vue-friendly-iframe
        :src="bankPage.src"
        v-if="bankPage.src"
        class="text-center"
      ></vue-friendly-iframe>
    </div>

    <!-- SELECT NO OF SEAT SECTION -->
    <section v-if="sectionName.noOfSeats && false">
      <!-- Add dynamic style url -->
      <div
        class="banner"
        :style="{ background: 'url(' + movieDetails.movie_card_banner + ')' }"
      ></div>
      <div class="select-seat-section" v-if="sectionName.noOfSeats">
        <div class="container px-2 px-md-3">
          <!-- SHOW THIS DIV FOR MY TICKET-E -->
          <div
            v-if="project == 'myticketi'"
            class="select-seat-container-myticket"
          >
            <!-- CONTENT -->
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mx-auto">
              <div class="row">
                <!-- HEADER -->
                <div class="col-12 py-3 bg-light rounded">
                  <div class="row">
                    <div class="col-3">
                      <strong>{{ $t("TICKET") }}</strong>
                    </div>
                    <div class="col-3">
                      <strong>{{ $t("PRICE") }}</strong>
                    </div>
                    <div class="col-4">
                      <strong>{{ $t("NO_OF_SEATS") }}</strong>
                    </div>
                    <div class="col-2"></div>
                  </div>
                </div>

                <!-- ADULT -->
                <div
                  v-for="(seatType, seatTypeIndex) in OnlySeatType"
                  :key="seatTypeIndex"
                  class="col-12 py-2 border-bottom"
                >
                  <div class="row align-self-center">
                    <div class="col-3 align-self-center">
                      <strong>{{ seatType.SeatType }}</strong>
                    </div>
                    <div class="col-3 align-self-center">
                      <strong>{{ seatType.Price }} {{ Currency }}</strong>
                    </div>
                    <div class="col-4">
                      <!-- HIDE THIS BUTTON WHEN ONE SEAT IS SELECTED -->
                      <!-- <button class="btn-first-add-myticket">Add</button> -->

                      <!-- SHOW THIS DIV WHEN ONE SEAT IS SELECTED -->
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-center
                          w-100
                          h-100
                        "
                      >
                        <button
                          v-on:click="onclickSubtract(seatTypeIndex)"
                          class="cursor-pointer btn-subtract-myticket"
                        >
                          -
                        </button>
                        <strong class="w-100px">{{ seatType.count }}</strong>
                        <button
                          :disabled="seatType.clickDisabled"
                          v-on:click="onclickAdd(seatTypeIndex)"
                          class="cursor-pointer btn-add-myticket"
                        >
                          +
                        </button>

                        <img
                          v-if="seatType.seatqty > '1'"
                          class="ml-2"
                          width="20px"
                          src="@/assets/img/icons8-info-50.png"
                          v-b-tooltip.hover
                          :title="
                            'Minimum Required seats is ' + seatType.seatqty
                          "
                        />
                      </div>
                    </div>
                    <div class="col-2">
                      <strong>{{ $t("ADD_SEATS") }}</strong>
                    </div>
                  </div>
                </div>

                <!-- TOTAL FOOTER -->
                <div class="col-12 py-3 bg-light rounded text-pink">
                  <div class="row">
                    <div class="col-3">
                      <strong>{{ $t("TOTAL") }}</strong>
                    </div>
                    <div class="col-3">
                      <strong>{{ totalAmount }} {{ Currency }}</strong>
                    </div>
                    <div class="col-4">
                      <strong>{{ totalNumberOfSeats }}</strong>
                    </div>
                    <div class="col-2"></div>
                  </div>
                </div>

                <!-- PROCEED BUTTON -->
                <div class="col-12 py-4">
                  <!-- ADD ACTIVE CLASS WHEN ONE TICKET IS SELECTED -->
                  <button
                    :class="
                      totalNumberOfSeats > 0 && MinSeatsFlag ? 'active' : ''
                    "
                    v-on:click="confirmNumber()"
                    :disabled="!(totalNumberOfSeats > 0 && MinSeatsFlag)"
                    class="btn-proceed-myticket"
                  >
                    {{ $t("PROCEED") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- SHOW THIS DIV FOR MY TICKET-E ENDS -->

          <!--------------------------------------------------------------------------->

          <!-- SHOW THIS DIV FOR TICKETAK  -->
          <div v-if="project == 'ticketak'" class="select-seat-container">
            <div>
              <div
                v-if="OnlySeatType.length > 0"
                style="border-bottom: 1px solid #cecece; padding-bottom: 14px"
                class="mb-4"
              >
                <!-- <h6 class="mb-3">Select the seat type</h6> -->
                <div class="row">
                  <div
                    v-for="(SingleSeatType, SeatKey) in OnlySeatType"
                    :key="SeatKey"
                    class="pr-2"
                    :class="
                      OnlySeatType.length == 1 ? 'col-12' : 'col-' + seatsClass
                    "
                  >
                    <button
                      v-on:click="onSelectSeatType(SingleSeatType.SeatType)"
                      disabled
                      style="border: none"
                      class="btn-rounded h-auto pointer-none"
                    >
                      {{ SingleSeatType.SeatType }}
                      <br />
                      ({{ Currency }} {{ SingleSeatType.Price }})
                    </button>
                  </div>
                  <!-- <div class="col-6 pl-2">
                <button v-on:click="onSelectSeatType('Silver')" :class="SeatType == 'Silver' ? 'active': ''" class="btn-rounded">Silver (AED 300)</button>
                  </div>-->
                </div>
              </div>
              <!-- disableSeats -->
              <div :class="SeatType.length > 0 || !getSeatLayout ? '' : ''">
                <h6 class="mb-3">{{ $t("HOW_MANY_SEATS") }}</h6>
                <ul class="select-seat-list">
                  <li
                    v-for="(number, index) in numberofSeatsArray"
                    :key="index"
                  >
                    <span
                      v-if="number == totalNumberOfSeats"
                      class="selected"
                      v-on:click="editNumberOfSeats(number)"
                      >{{ number }}</span
                    >
                    <span v-else v-on:click="editNumberOfSeats(number)">{{
                      number
                    }}</span>
                  </li>
                </ul>
              </div>

              <button
                v-on:click="confirmNumber()"
                :class="totalNumberOfSeats > 0 ? 'active' : ''"
                class="btn-confirm"
              >
                {{ $t("PROCEED") }}
              </button>
            </div>
            <!-- SHOW THIS DIV FOR TICKETAK ENDS -->
          </div>
        </div>
      </div>
    </section>

    <!-- SEATLAYOUT SECTION -->
    <div v-if="this.SeatErrormessage != ''" class="seat-layout-message">
      <h3 className="font-weight-bold">{{ this.SeatErrormessage }}</h3>
    </div>

    <section
      class="seat_layout_container seat-layout-two"
      v-if="sectionName.seatLayout && this.SeatErrormessage == ''"
    >
      <!-- details -->
      <div class="d-flex">
        <div class="section-seatlayout">
          <!-- <div class="   text-left text-pink">
            <div class="small">{{cinemaDetails.MovieTitle}}</div>
            <div class="small">{{cinemaDetails.Name}}</div>
            <div class="small">{{showDate.date}} {{showDate.month}} {{showDate.year}}, {{SchTime}}</div>
          </div>-->
          <!-- v-if="sectionName.seatLayout" -->

          <section class="d-md-none text-left small text-dark mb-2">
            <div>{{ cinemaDetails.MovieTitle }}</div>
            <div>{{ cinemaDetails.Name }}</div>
            <div>
              {{ showDate.date }} {{ showDate.month }} {{ showDate.year }},
              {{ SchTime }}
            </div>
          </section>

          <!--Example-->
          <!-- <div>
                <img src="@/assets/img/aquaman_1475_555.jpg"/>
              </div>
              <div>
                <img src="@/assets/img/aquaman_1475_555.jpg"/>
              </div>
              <div>
                <img src="@/assets/img/aquaman_1475_555.jpg"/>
              </div> -->
          <!---Example Ends-->
          <section class="seat-layout-shows mb-3" v-if="false">
            <Slick
              ref="cinemaMovieTimeSlick"
              class="shedule_seat"
              v-if="allShowTimes.length > 0"
              :options="seatLayoutDateSlider"
            >
              <!--  -->
              <section
                v-for="(singleShow, showTimeIndex) in allShowTimes"
                :key="showTimeIndex"
              >
                <div
                  v-on:click="onClickShowTime(singleShow)"
                  :class="singleShow.SchID == scheduleID ? 'active' : ''"
                  class="seat-datebox"
                >
                  {{ singleShow.ShowTime }}

                  {{ singleShow.Format !== "2D" ? singleShow.Format : "" }}
                </div>
              </section>
              <!-- <div
                v-for="(singleShow, showTimeIndex) in allShowTimes"
                :key="showTimeIndex"
                >
                <div
                  v-if="singleShow.Format !== '2D'"

                  v-on:click="onClickShowTime(singleShow)"
                  :class="singleShow.SchID == scheduleID ? 'active' : ''"
                  class="seat-datebox"
                >
                  {{ singleShow.ShowTime }}

                  ({{ singleShow.Format }})
                </div>
                <div
                  v-else
                  v-on:click="onClickShowTime(singleShow)"
                  :class="singleShow.SchID == scheduleID ? 'active' : ''"
                  class="seat-datebox"
                >
                  {{ singleShow.ShowTime }}

                </div>
              </div> -->
            </Slick>
          </section>
          <!-- <div class="banner"></div> -->
          <div v-if="seatTypes.length > 0" class="seat_layout_nav">
            <hr class="w-75" />
            <nav class="navigation w-100">
              <ul class="seat-appearance-list">
                <li>{{ $t("SOLD") }}</li>
                <li>{{ $t("AVAILABLE") }}</li>
                <li>{{ $t("SELECTED") }}</li>
              </ul>
            </nav>
          </div>
          <div class="seat_layout mb-3 seat-layout-one">
            <!-- :id="'seat-'+addhyphen(seatType.SeatType)" -->
            <table
              class="seat-layout-table mx-auto"
              v-for="(seatType, seatTypeIndex) in seatTypes"
              :key="seatTypeIndex"
              :style="'width:' + SeatCatWidth[seatTypeIndex] + 'px'"
            >
              <tr v-if="seatTypeIndex == 0">
                <td colspan="50"></td>
              </tr>
              <!-- disableSeats  :class="project == 'myticketi' ? (SeatTypeMT != (seatType.SeatType && /_1/.test(seatType.SeatType) ? seatType.SeatType.replace(/_1/g,'') : seatType.SeatType) ? 'disableSeats' :'') : ''" -->
              <tbody>
                <tr>
                  <td colspan="50">
                    <div class="text-left pb-2 pt-3">
                      <div v-if="cinemaDetails.CinemaID != 33">
                        <span v-if="seatType.SeatType == 'balcony' && cinemaDetails.CinemaID == '45'">
                        Premium
                      </span>
                        <span v-else-if="seatType.SeatType == 'balcony'"> VIP </span>
                        
                        <span
                          v-else-if="
                            seatType.SeatType == 'orchestra' &&
                              cinemaDetails.CinemaID == '35'
                          "
                        >
                          VIP Gold (RECLINERS)
                        </span>
                        <span
                        v-else-if="
                          seatType.SeatType == 'orchestra' &&
                            cinemaDetails.CinemaID == '45'
                        "
                      >
                        VIP
                      </span>
                      
                        <span v-else-if="seatType.SeatType == 'orchestra'">
                          VIP Gold
                        </span>
                        <!-- &&
                              seatType.screen_id == '65' -->
                        <span
                          v-else-if="
                            seatType.SeatType == 'Standard' &&
                              seatType.screen_id == '65'
                          "
                        >
                          VIP DIAMOND (RECLINERS)
                        </span>
                        <span v-else-if="seatType.SeatType == 'Standard'">
                          STANDARD
                        </span>
                        <span v-else>
                          {{
                            seatType.SeatType && /_1/.test(seatType.SeatType)
                              ? seatType.SeatType.replace(/_1/g, "")
                              : seatType.SeatType
                          }}
                        </span>
                        <span class="text-muted" v-if="seatType.Price != ''">
                          ( {{ Currency }} {{ seatType.Price }} )</span
                        >
                      </div>

                      <div v-else>
                        {{
                          seatType.SeatType && /_1/.test(seatType.SeatType)
                            ? seatType.SeatType.replace(/_1/g, "")
                            : seatType.SeatType
                        }}

                        <span class="text-muted" v-if="seatType.Price != ''"
                          >( {{ Currency }} {{ seatType.Price }} )</span
                        >
                      </div>
                    </div>
                    <div v-if="seatType.isuniqueSeat" class="text-left">
                      {{
                        seatType.SeatType && /_1/.test(seatType.SeatType)
                          ? seatType.SeatType.replace(/_1/g, "")
                          : seatType.SeatType
                      }}
                      : {{ Currency }} {{ seatType.Price }}
                    </div>
                    <div v-else class="text-left">
                      {{ myticketDisplaySeatType }}
                    </div>
                  </td>
                </tr>

                <!-- v-if="cinemaDetails.CinemaID != 17 -->
                <tr
                  v-for="(seatsArray, seatArrayIndex) in seatLayout"
                  :key="seatArrayIndex"
                  class="sbtr"
                  v-bind:class="
                    seatsArray[0].SeatType == seatType.SeatType ? '' : 'd-none'
                  "
                >
                  <td
                    v-for="(singleSeat, singleSeatIndex) in seatsArray"
                    :key="singleSeatIndex"
                    v-bind:class="
                      singleSeat.Status == 5
                        ? ' d-none ' + singleSeat.ClassName
                        : singleSeat.ClassName
                    "
                  >
                    <div
                      v-if="
                        singleSeat.SeatType == seatType.SeatType &&
                          singleSeat.Status == 1 &&
                          singleSeat.Occupied == '2'
                      "
                      class="big-seat seat-available"
                      v-on:click="
                        handlerSeatSelected(
                          singleSeat,
                          seatArrayIndex,
                          singleSeatIndex,
                          null,
                          null,
                          $event,
                          seatType.SeatType
                        )
                      "
                      v-bind:class="
                        singleSeat.SelectStatusFlag
                          ? ' big-seat selectedSeat'
                          : ''
                      "
                    >
                      {{ singleSeat.SeatName }}
                    </div>
                    <div
                      v-if="
                        singleSeat.SeatType == seatType.SeatType &&
                          singleSeat.Status == 1 &&
                          !singleSeat.Occupied
                      "
                      class="seat-available"
                      v-on:click="
                        handlerSeatSelected(
                          singleSeat,
                          seatArrayIndex,
                          singleSeatIndex,
                          null,
                          null,
                          $event,
                          seatType.SeatType
                        )
                      "
                      v-bind:class="
                        singleSeat.SelectStatusFlag ? ' selectedSeat' : ''
                      "
                    >
                      {{ singleSeat.SeatName }}
                    </div>

                    <div
                      class="big-seat seat-unavailable"
                      v-if="
                        singleSeat.SeatType == seatType.SeatType &&
                          singleSeat.Occupied == '2' &&
                          singleSeat.SeatName != '' &&
                          (singleSeat.Status == 2 || singleSeat.Status == 0)
                      "
                    >
                      {{ singleSeat.SeatName }}
                    </div>

                    <div
                      class="seat-unavailable"
                      v-if="
                        singleSeat.SeatType == seatType.SeatType &&
                          !singleSeat.Occupied &&
                          singleSeat.SeatName != '' &&
                          (singleSeat.Status == 2 || singleSeat.Status == 0)
                      "
                    >
                      {{ singleSeat.SeatName }}
                    </div>
                    <div
                      v-if="
                        singleSeat.SeatType == seatType.SeatType &&
                          singleSeat.Status == 0
                      "
                      style="width: 30px"
                    ></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="seatTypes.length > 0"
            class="screen sticky-top mb-3"
            style="max-width: 700px; margin: 0 auto"
          >
            <img src="@/assets/img/screen-blue.png" class="screen-img" />

            <div class="screen-text pt-3">
              <p>{{ cinemaDetails.SBScreenName }}</p>
              {{ $t("SCREEN_THIS_WAY") }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CHECKOUT DETAILS SECTION -->
    <section class="bg-light finalCheckout mt-2">
      <div
        v-if="sectionName.checkout"
        class="wrapper pb-4"
        style="min-height: 100vh"
      >
        <div class="row flex-row-reverse mx-0">
          <div class="col-md-12 col-lg-8 order-2 order-md-1 mb-3 px-0 px-md-3">
            <!-- Food & Beverages Section -->

            <section
              class="section-offer pt-0 pb-2 mb-3"
              v-if="foodAndBeverages.allListing.length > 0"
            >
              <div class="d-flex justify-content-between">
                <h6
                  v-b-toggle.fnbSection
                  class="pt-3 font-weight-bold mb-2 text-pink w-100"
                >
                  Food & Beverages
                  <span
                    style="color: #000000; font-size: 15px"
                    v-if="fnbtotal > 0"
                    >: {{ Currency }} {{ fnbtotal }} Added to the cart</span
                  >
                </h6>

                <a
                  v-if="fnbCollapsed"
                  @click="skipFnB()"
                  class
                  style="color: #0000ee; margin-top: 8px; cursor: pointer"
                  >SKIP</a
                >
              </div>

              <div v-if="fnbCollapsed" class="align-items-center"></div>
              <b-collapse v-model="fnbCollapsed" visible id="fnbSection">
                <div class="col-12 col-md-11 px-0">
                  <div class="my-4 text-center cus-list mb-5 d-none">
                    <p class="eTitle eTitlewhite">
                      <img
                        src="@/assets/img/svg/fb-icon.svg"
                        class="img-fluid pb-2"
                        v-bind:class="langName == 'ar' ? 'ml-2' : 'mr-2'"
                      />
                      {{ allLanguageData.GrabABite }}!
                      <span class="selected-items"
                        >{{ foodAndBeverages.allListing.length }} ITEMS</span
                      >
                    </p>
                    <!-- separator -->
                    <div class="whitedotline-box w-100">
                      <hr class="white-dotline" />
                      <span class="d-none"></span>
                    </div>
                    <!-- separator  END -->
                    <ul class="list-inline fbCat">
                      <li
                        class="list-inline-item"
                        :class="{
                          active: foodAndBeverages.selectedCategory == 'All'
                        }"
                        v-on:click="onSelectCategory('All')"
                      >
                        All
                      </li>
                      <li
                        v-for="(category,
                        foodCategoryIndex) in foodAndBeverages.listing"
                        :key="foodCategoryIndex"
                        class="list-inline-item"
                        v-on:click="
                          onSelectCategory(category[0].Category.Title)
                        "
                        :class="{
                          active:
                            foodAndBeverages.selectedCategory ==
                            category[0].Category.Title
                        }"
                      >
                        {{ category[0].Category.Title }}
                      </li>
                    </ul>
                    <!-- separator -->
                    <div class="whitedotline-box w-100">
                      <hr class="white-dotline" />
                      <span class="d-none"></span>
                    </div>
                    <!-- separator  END -->
                  </div>

                  <!-- ALL FNB -->
                  <div
                    v-if="foodAndBeverages.allListing.length > 0"
                    class="row mx-0 foodBevrage"
                  >
                    <template
                      v-if="foodAndBeverages.selectedCategory == 'All'"
                      v-for="(categories, fb) in foodAndBeverages.listing"
                    >
                      <div
                        class="col-md-6 col-lg-4 mb-4 mb-md-5 sub-box"
                        :index="fb"
                        v-for="(fbBox, fbIndex) in categories"
                        :key="fbIndex + fbBox.ItemName"
                      >
                        <div class="h-100 premiere-fb-box red-fb-box">
                          <div
                            class="
                              align-items-center
                              text-center text-white
                              small
                            "
                          >
                            <img
                              v-if="fbBox.ThumbnailImage.includes('/assets/')"
                              :src="fbBox.ThumbnailImage"
                              v-bind:alt="fbBox.ItemName"
                            />
                            <img
                              v-else
                              src="@/assets/img/demo-img.png"
                              class="demo-img"
                              v-bind:alt="fbBox.ItemName"
                            />
                          </div>
                          <div class="fbDetails">
                            <div class="fnb-info">
                              <p class="fb-name">
                                {{ fbBox.ItemName }}
                                <!-- <small class="text-lowercase ml-1">{{fbBox.Description}}</small> -->
                              </p>
                              <p class="fb-desc">
                                <small class="text-lowercase">{{
                                  fbBox.Description
                                }}</small>
                              </p>
                              <p class="fb-price">Qty: {{ fbBox.Qty }}</p>
                              <p class="fb-price">
                                {{ fbBox.Currency }}
                                {{ changeNumberFormat(fbBox.Amount) }}
                              </p>
                            </div>
                            <div
                              class="d-flex justify-content-end pr-0 pr-xl-3"
                            >
                              <!-- <div>
                      <img src="@/assets/img/svg/veg-icon.svg" class="img-fluid">
                      <img src="@/assets/img/svg/nonVeg-icon.svg" class="img-fluid d-none">
                              </div>-->
                              <div>
                                <div>
                                  <div
                                    class="d-flex counter-box mr-0 mr-md-3"
                                    v-bind:class="
                                      langName == 'ar' ? 'ar-counter-box' : ''
                                    "
                                  >
                                    <button
                                      class="cursor-pointer btn-add-myticket"
                                      style="
                                        width: 25px;
                                        height: 25px;
                                        font-size: 14px;
                                      "
                                      v-on:click="
                                        onSelectFoodItem(
                                          fbBox,
                                          'subtract',
                                          fbIndex
                                        )
                                      "
                                      id="decrease"
                                      type="button"
                                      data-inc="-1"
                                    >
                                      -
                                    </button>
                                    <div
                                      class="output"
                                      style="font-size: 14px; margin: 0 10px"
                                      id="output"
                                    >
                                      {{ fbBox.Qty }}
                                    </div>
                                    <button
                                      class="cursor-pointer btn-add-myticket"
                                      style="
                                        width: 25px;
                                        height: 25px;
                                        font-size: 14px;
                                      "
                                      v-on:click="
                                        onSelectFoodItem(fbBox, 'add', fbIndex)
                                      "
                                      id="increase"
                                      type="button"
                                      data-inc="1"
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- ALL FNB ENDS -->

                    <!-- SELECTED FNB -->
                    <div
                      v-if="foodAndBeverages.selectedCategory != 'All'"
                      class="col-md-6 col-lg-4 mb-4 mb-md-5"
                      v-for="(fbBox, fb2) in foodAndBeverages.listing[
                        foodAndBeverages.selectedCategory
                      ]"
                      :key="fb2"
                    >
                      <div class="h-100 premiere-fb-box red-fb-box border">
                        <div class="align-items-center">
                          <img
                            v-if="fbBox.ThumbnailImage.includes('/assets/')"
                            :src="fbBox.ThumbnailImage"
                            v-bind:alt="fbBox.ItemName"
                          />
                          <img
                            v-else
                            src="@/assets/img/demo-img.png"
                            class="demo-img"
                            v-bind:alt="fbBox.ItemName"
                          />
                          <!-- <img src="@/assets/img/Layer.png"> -->
                        </div>
                        <div class="fbDetails">
                          <div>
                            <p class="fb-name">
                              {{ fbBox.ItemName }}
                              <!-- <small class="text-lowercase ml-1">{{fbBox.Qty}}</small> -->
                            </p>
                            <p class="fb-price">Qty: {{ fbBox.Qty }}</p>
                            <p class="fb-price">
                              {{ fbBox.Currency }}
                              {{ changeNumberFormat(fbBox.Amount) }}
                            </p>
                          </div>
                          <div class="justify-content-end pr-0 pr-xl-3">
                            <!-- <div>
                    <img src="@/assets/img/svg/veg-icon.svg" class="img-fluid">
                    <img src="@/assets/img/svg/nonVeg-icon.svg" class="img-fluid d-none">
                            </div>-->
                            <div>
                              <div>
                                <div
                                  class="counter-box mr-0 mr-md-3"
                                  v-bind:class="
                                    langName == 'ar' ? 'ar-counter-box' : ''
                                  "
                                >
                                  <button
                                    class="cursor-pointer btn-add-myticket"
                                    style="
                                      width: 25px;
                                      height: 25px;
                                      font-size: 14px;
                                    "
                                    v-on:click="
                                      onSelectFoodItem(fbBox, 'subtract', fb2)
                                    "
                                    id="decrease"
                                    type="button"
                                    data-inc="-1"
                                  >
                                    -
                                  </button>
                                  <div
                                    class="output"
                                    id="output"
                                    style="font-size: 14px; margin: 0 10px"
                                  >
                                    {{ fbBox.Qty }}
                                  </div>
                                  <button
                                    class="cursor-pointer btn-add-myticket"
                                    style="
                                      width: 25px;
                                      height: 25px;
                                      font-size: 14px;
                                    "
                                    v-on:click="
                                      onSelectFoodItem(fbBox, 'add', fb2)
                                    "
                                    id="increase"
                                    type="button"
                                    data-inc="1"
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- SELECTED FNB ENDS -->
                    <div class="w-100">
                      <button
                        type="button"
                        class="btn-confirm"
                        :disabled="fnbtotal > 0 ? false : true"
                        :class="fnbtotal > 0 ? 'active' : ''"
                        @click="bookFoodAndBeverages"
                      >
                        Continue
                      </button>
                      <!-- {{bookingDetails.total_amt}})
                      ({{Currency}}-->
                    </div>
                  </div>
                  <div v-else class="eTitle eTitlewhite text-center">
                    No FNB Data Found
                  </div>
                </div>
              </b-collapse>
            </section>

            <!-- Food & Beverages Section -->
            <section
              class="section-offer pt-0 pb-2"
              :class="isRTL ? 'rtl' : ''"
            >
              <p
                class="pt-3 font-20 font-weight-bold mb-2 text-pink"
                id="errorMsgDisplay"
              >
                {{ onErrorMeesage }}
              </p>

              <h6
                v-b-toggle.checkout
                v-if="isUserLoggedIn"
                class="pt-3 font-weight-bold mb-2 text-pink"
              >
                {{ $t("CHECKOUT") }}
              </h6>
              <h6
                v-b-toggle.checkout
                v-else
                class="pt-3 font-weight-bold mb-2 text-pink"
              >
                {{ $t("CHECKOUT_AS_GUEST") }}
              </h6>
              <!-- v-model="firstCollapsed"  -->
              <b-collapse visible id="checkout">
                <div class="small mb-2">
                  <span v-if="project == 'ticketak'">{{
                    $t("YOUR_TICKETS")
                  }}</span>
                  <div v-if="project == 'myticketi'">
                    <p class="text-pink">
                      <!-- <strong>{{ $t("FOR_PAYMENT") }}</strong> -->
                      {{ $t("PLEASE_MAKE_SURE_THAT_YOU_ENTER") }}
                      <!-- {{ $t("WE_ONLY_ACCEPT") }} -->
                    </p>
                    <p style="color: black">
                      {{ $t("IF_YOU_ARE_A_REGISTERED_USER") }}
                    </p>
                  </div>
                </div>
                <form
                  data-vv-scope="bookUser"
                  class="col-md-12 col-lg-10 col-xl-11 px-0"
                >
                  <div class="w-100 mb-3">
                    <div class="row">
                      <div class="col-md-6 mb-2 mb-md-0">
                        <input
                          v-validate="'required|email'"
                          name="email"
                          v-on:keyup="onKeyUp($event, 'email')"
                          v-model="userDetails.email"
                          type="text"
                          :placeholder="$t('ENTER_YOUR_EMAILADDRESS')"
                          class="form-control"
                        />
                        <div
                          v-show="errors.has('bookUser.email')"
                          class="fs-11 text-danger my-2"
                        >
                          {{ errors.first("bookUser.email") }}
                        </div>
                      </div>

                      <!-- <VuePhoneNumberInput

                        id="phoneNumber1"
                        v-model="status.phoneNumberStatus"
                        v-on:keyup="onKeyUp($event, 'mobile')"
                        color="dodgerblue"
                        :dark="dark"
                        :disabled="disabled"
                        :ignored-countries="countriesIgnored"
                        :preferred-countries="countriesList"
                        default-country-code="BH"
                        :loader="hasLoaderActive"
                        clearable
                        :error="hasErrorActive"
                        class="mb-2"

                        @update="resultsExample = $event"

                          /> -->

                      <div class="col-md-6 mb-2 mb-md-0">
                        <VuePhoneNumberInput
                          v-model="userDetails.phoneNumber"
                          @update="onKeyUp($event, 'mobile')"
                          :default-country-code="
                            countryList.find(
                              o => o.phonecode == userDetails.countryCode
                            ) &&
                              countryList.find(
                                o => o.phonecode == userDetails.countryCode
                              ).isoCode
                          "
                          id="phoneNumber1"
                        />
                        <!-- <div class="row mx-0 align-items-center">
                          <div class="col-3 px-0 country-code-drop">
                            <b-dropdown
                              v-if="CountryCodeList.length > 0"
                              class="pc-input form-control"
                              :text="'+' + DefaultCountryCode"
                              variant="default"
                              slot="append"
                            >
                              <b-dropdown-item
                                class
                                v-on:click="onChangeCountry(country)"
                                v-for="(country,
                                countryIndex) in CountryCodeList"
                                :key="countryIndex"
                                >{{ country.CountryName }} (+{{
                                  country.CountryISOCode
                                }})
                              </b-dropdown-item>
                            </b-dropdown>
                          </div>

                          <div
                            class="col-9 px-0 pr-0 pr-xl-2"
                            :class="isRTL ? 'pr-2' : 'pl-2 '"
                          >
                            <input
                              v-validate="'required|min:9|max:10'"
                              name="Phone Number"
                              v-on:keyup="onKeyUp($event, 'mobile')"
                              v-model="userDetails.phoneNumber"
                              type="number"
                              :placeholder="$t('ENTER_YOUR_CONTACTNUMBER')"
                              class="form-control"
                            />
                          </div>
                        </div> -->
                        <div
                          v-show="errors.has('bookUser.Phone Number')"
                          class="fs-11 text-danger my-2"
                        >
                          {{ errors.first("bookUser.Phone Number") }}
                        </div>
                      </div>
                      <div
                        class="col-md-12"
                        v-if="isStudent"
                        style="margin-top: 20px"
                      >
                        <div class="align-items-center w-100 mb-3">
                          <div v-if="!promoApplied">
                            <input
                              v-validate="'alpha_num'"
                              v-on:change="onKeyUp($event, 'studentCheck')"
                              v-model="studentCheck"
                              type="checkbox"
                              id="studentCheckoutTerms"
                            />
                            <label for="studentCheckoutTerms" class="mb-0">
                              <strong>I want to avail student discount</strong>
                              <!--<router-link target="_blank" to="/tnc" class="text-pink">
                            &nbsp;
                            <u>Terms & Conditions</u>
                              </router-link>-->
                            </label>
                          </div>
                          <div v-else>
                            <strong
                              >You have already availed a discount.</strong
                            >
                          </div>
                          <div v-if="studentCheck" style="margin-top: 10px">
                            <div v-for="i in totalNumberOfSeats">
                              <input
                                v-model="studentIDs[i]"
                                name="'student'+i"
                                type="text"
                                placeholder="Please enter valid student ID"
                                class="form-control"
                                style="margin-top: 10px; width: 50%"
                                v-on:keyup="promotionDiscount()"
                              />
                              <span
                                v-if="
                                  studentIDs[i] != '' &&
                                    !/^[0-9a-zA-Z]+$/.test(studentIDs[i])
                                "
                                class="help text-pink"
                                >Student ID should not contain special
                                characters.</span
                              >
                              <span
                                v-if="
                                  studentIDs[i] != '' &&
                                    !/^.{0,15}$/.test(studentIDs[i])
                                "
                                class="help text-pink"
                                >Student ID must not be more than 15
                                characters.</span
                              >
                            </div>

                            <button
                              type="button"
                              class="btn-confirm active d-none"
                              style="margin-top: 10px"
                              @click="validateBeforeSubmit('bookUser')"
                            >
                              Submit
                            </button>
                            <p class="small mb-2 mt-2 text-pink">
                              * Duplicate student id's will not be considered
                              for discount.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="project == 'myticketi'">
                    <p style="font-size: 10px" class="text-pink d-none">
                      Kindly note, Payment made via Debit or Credit card should
                      be associated with the same email id & phone number as
                      registered with your card issuing bank. Registered users
                      will get the ticket confirmation on email id & mobile
                      number used while registering with Wanasa Time.
                    </p>
                  </div>
                  <div
                    v-if="!isUserLoggedIn"
                    class="w-100 mb-3"
                    :class="isRTL ? 'text-right' : ''"
                  >
                    {{ $t("ALREADY_A_MEMBER") }}
                    <a
                      v-b-modal.signIn
                      @contextmenu="handler($event)"
                      class="text-pink"
                      style="cursor: pointer"
                    >
                      <u>{{ $t("LOGIN") }}&nbsp;</u> </a
                    >Or
                    <a
                      v-b-modal.signUp
                      @contextmenu="handler($event)"
                      class="text-pink"
                      style="cursor: pointer"
                    >
                      <u>{{ $t("REGISTER") }}&nbsp;</u> </a
                    >{{ $t("NOW_FOR_MORE") }}
                  </div>

                  <div
                    class="d-flex align-items-center w-100 mb-3"
                    :style="isRTL ? 'gap:10px' : ''"
                  >
                    <input
                      v-on:change="onKeyUp($event, 'conditions')"
                      v-model="conditions"
                      type="checkbox"
                      id="guestCheckoutTerms"
                    />
                    <label for="guestCheckoutTerms" class="mb-0">
                      {{ $t("I_ACCEPT_THE") }}
                      <router-link target="_blank" to="/tnc" class="text-pink">
                        &nbsp;
                        <u>{{ $t("TERMS_CONDITIONS") }}</u>
                      </router-link>
                    </label>
                  </div>

                  <div class="small mb-1 text-muted">
                    {{ $t("OPERATIONAL_TERMS_CONDITIONS") }}
                  </div>
                  <ul class="tnc">
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("TICKET_COMPULSORY") }}
                    </li>
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("AGE_RESTRISTIONS") }}
                    </li>
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("AT_THE_CINEMA_PROOF") }}
                      <!--<span v-if="project == 'ticketak'">UAE</span>
                      <span v-if="project == 'Bahrain'">Kenya</span>-->
                    </li>
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("RETURNS_EXCHANGE") }}
                      <!--<span v-if="project == 'ticketak'">Ticketak</span>
                      <span v-if="project == 'myticketi'">MyTiketi</span>-->
                    </li>
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("DECISIONS_TAKEN_CINEMAS") }}.
                    </li>
                    <li :class="isRTL ? 'text-right' : ''">
                      {{ $t("OUTSIDE_FOOD_BEVERAGES") }}
                    </li>
                  </ul>
                  <template v-if="bookingTermsAndConditions">
                    <div v-html="bookingTermsAndConditions"></div>
                  </template>

                  <!-- <div class="d-flex align-items-center w-100 mb-3 tandc">
                      <label for="guestCheckoutTerms" class="mb-0 chkbox active d-block">
                        <input
                        v-on:change="onKeyUp($event,'conditions')"
                        v-model="conditions"
                        type="checkbox"
                        id="guestCheckoutTerms"
                        class="d-none"
                        />
                      </label>
                      I accept the
                      <router-link target="_blank" to="/tnc" class="text-pink">
                        &nbsp;<u>Terms & Conditions</u>
                      </router-link>
                  </div>-->
                  <!-- <div class="d-flex align-items-center w-100 mb-3">
                    <input
                      v-on:change="onKeyUp($event,'conditions')"
                      v-model="conditions"
                      type="checkbox"
                      id="guestCheckoutTerms"
                    />
                    <label for="guestCheckoutTerms" class="mb-0">
                      I accept the
                      <router-link target="_blank" to="/tnc" class="text-pink">
                        &nbsp;
                        <u>Terms & Conditions</u>
                      </router-link>
                    </label>
                  </div>-->
                  <div class="w-100 d-flex">
                    <!-- && isValidNumber -->
                    <button
                      @click="validateBeforeSubmit('bookUser')"
                      type="button"
                      :disabled="checkoutButtonStatus ? false : true"
                      :class="checkoutButtonStatus ? 'active' : ''"
                      class="btn-confirm"
                    >
                      {{ $t("CONTINUE") }}
                    </button>
                    <!-- {{bookingDetails.total_amt}})
                    ({{Currency}}-->
                  </div>
                </form>

                <!-- EREOFOINFRNFILJRBFUHRBFURBFKRBFBUYBFUYKRBFU -->
              </b-collapse>
            </section>

            <!-- OFFERS SECTION FINAL  -->
            <section
              class="py-2 cursor-pointer section-offer mt-3 offers-collapse"
            >
              <h6
                v-b-toggle.offers_collapse
                class="py-2 font-weight-bold mb-0 c-pointer text-pink"
              >
                OFFERS AND DISCOUNTS
              </h6>

              <b-collapse id="offers_collapse">
                <!-- v-if="isVoucherApplicable == true" -->
                <div class="offers-grid">
                  <div>
                    <input
                      v-on:keyup="onKeyUp($event, 'offer')"
                      type="text"
                      v-model="voucherCode"
                      class="voucher-input mt-3"
                      placeholder="Enter Voucher Code"
                    />
                    <span style="mt-2">{{ VoucherMsg }}</span>
                  </div>

                  <!-- :disabled="
                      voucherCode == '' && voucherApplied == false ? false : true
                    " -->
                  <button
                    v-if="voucherApplied == false"
                    :disabled="
                      voucherCode == '' || voucherApplied == true ? true : false
                    "
                    :class="
                      voucherCode == '' || voucherApplied == true
                        ? ' '
                        : 'active'
                    "
                    @click="onApplyPromocode('1')"
                    class="btn-confirm"
                  >
                    APPLY
                  </button>
                  <button
                    :disabled="
                      voucherCode != '' && voucherApplied == true ? false : true
                    "
                    :class="
                      voucherCode != '' && voucherApplied == true
                        ? 'active'
                        : ''
                    "
                    v-else
                    @click="onApplyPromocode('0')"
                    class="btn-confirm"
                  >
                    Remove
                  </button>
                </div>
              </b-collapse>
            </section>
            <!-- <section
              class="
                pt-0
                text-center
                cursor-pointer
                section-offer
                mt-3
                offers-collapse
              "
            >
              <button
                type="button"
                @click="onclickpaynow()"
                style="margin-top: 15px"
                :disabled="checkoutButtonStatus && checkDiscount ? false : true"
                :class="checkoutButtonStatus && checkDiscount ? 'active' : ''"
                class="btn-confirm"
              >
                Pay Now
              </button>
            </section> -->

            <section
              class="pt-0 section-offer mt-3 offers-collapse"
              :class="this.showPaymentCollapse ? 'd-block' : 'd-none'"
              id="payment-mode-section"
            >
              <h6
                v-b-toggle.payment_options
                class="pt-3 font-weight-bold mb-0 c-pointer text-pink"
              >
                PAYMENT OPTIONS
              </h6>

              <b-collapse visible id="payment_options">
                <!--  -->
                <!-- :vertical="screenWidth" :pills="screenWidth" -->
                <b-tabs class="payment-tabs">
                  <b-tab
                    class=""
                    v-for="(data, index) in this.payment_options"
                    :key="index"
                    @click="getPaymentName(data)"
                  >
                    <template #title>
                      <img
                        v-if="data.title == 'CREDIT CARD'"
                        :src="data.image"
                        alt="card"
                        width="70px"
                        height="14px"
                        margin-right="8px"
                      />
                      <img
                        v-if="data.title == 'DEBIT CARD'"
                        :src="data.image"
                        alt="card"
                        width="15px"
                        height="18px"
                        margin-right="8px"
                      />

                      <img
                        v-if="
                          data.title == 'SCB CREDIT CARD OFFER' &&
                            !cinemaDetails.MovieTitle.includes('FIFA')
                        "
                        :src="data.image"
                        alt="card"
                        width="15px"
                        height="18px"
                        margin-right="8px"
                      />
                      {{ data.title }}
                    </template>
                    <div class="text-center">
                      <button
                        @click="onclickpaynow(index)"
                        type="submit"
                        class="btn-confirm active"
                      >
                        {{ $t("PROCEED") }}
                      </button>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-collapse>

              <div class="payment-frame">
                <div id="3ds_iframe"></div>
              </div>
            </section>
          </div>
          <div class="d-md-none d-block text-pink pr-2 fs-18">
            {{ timer.minutes }} : {{ timer.seconds }} left
          </div>
          <div class="col-md-12 col-lg-4 mb-3 px-0 px-md-3">
            <div class="sticky-selected-movie-details">
              <div class="section-booking pb-0">
                <h6 class="font-weight-bold">{{ $t("BOOKING_SUMMARY") }}</h6>
                <div class="d-flex">
                  <div class="img_poster">
                    <img :src="movieDetails.movie_card_img" alt />
                  </div>

                  <div class="d-flex selectedMovieInfo">
                    <div class="movieTitle mb-1">{{ movieDetails.title }}</div>

                    <div class="fpx">
                      <span>{{ bookingDetails.desc }}</span>
                      <!-- <span class="mx-1">|</span>
                                            <span>{{movieDetails.genre}}</span>
                                            <span>|</span>
                      <span class="format ml-1">{{movieDetails.format}}</span>-->
                    </div>

                    <div class="font-weight-bold">
                      <span
                        >{{ showDate.date }} {{ showDate.month }}
                        {{ showDate.year }}</span
                      >
                      <span class="mx-1">|</span>
                      <span>{{ bookingDetails.time }}</span>
                    </div>
                    <!-- -->

                    <div
                      class="b"
                      v-b-tooltip.hover
                      :title="cinemaDetails.Name"
                    >
                      {{ cinemaDetails.Name }}
                    </div>
                  </div>
                </div>
                <hr />
                <!-- SEAT INFO -->
                <div
                  class="font-weight-bold d-flex justify-content-between mb-3"
                >
                  <div>
                    <div class="text-muted small font-weight-bold mb-1">
                      {{ $t("SEATS") }} ({{ totalNumberOfSeats }}
                      <span v-if="SeatType == 'balcony' && cinemaDetails.CinemaID == '45'">
                        Premium
                      </span>
                      <span v-else-if="SeatType == 'balcony'">
                        VIP
                      </span>
                      <span
                        v-else-if="
                          SeatType == 'orchestra' &&
                            cinemaDetails.CinemaID == '35'
                        "
                      >
                        VIP Gold RECLINERS
                      </span>
                      <span
                        v-else-if="
                          SeatType == 'orchestra' &&
                            cinemaDetails.CinemaID == '45'
                        "
                      >
                        VIP
                      </span>
                      <span v-else-if="SeatType == 'orchestra'">
                        VIP Gold
                      </span>
                      <span
                        v-else-if="
                          SeatType == 'Standard' &&
                            cinemaDetails.ScreenID == '65'
                        "
                      >
                        VIP DIAMOND RECLINERS
                      </span>
                      <span v-else-if="SeatType == 'Standard'">
                        STANDARD
                      </span>
                      <span v-else> {{ SeatType }} </span>

                      )
                    </div>

                    <ul
                      class="list-inline selected-seat"
                      v-if="getSeatLayout == true"
                    >
                      <li
                        v-for="(seat, seatKey) in selectedSeats"
                        :key="seatKey"
                      >
                        {{ seat.SeatName }}
                      </li>
                    </ul>
                    <div v-else>{{ $t("OPEN_SEATING") }}</div>
                  </div>
                  <div class="text-right">
                    <div class="text-muted small font-weight-bold mb-1">
                      {{ $t("SCREEN") }}
                    </div>
                    <div>
                      CINEMA {{ cinemaDetails.SBScreenName.split(" ")[1] }}
                    </div>
                  </div>
                </div>
                <hr />
                <div class="bookingInfo">
                  <div>
                    <div class="text-muted small mb-3 font-weight-bold">
                      {{ $t("BOOKING_DETAILS") }}
                    </div>
                    <!-- <div class="mb-3">Tickets ({{SeatType}} x {{totalNumberOfSeats}})</div> -->
                    <div class="mb-3">
                      {{ $t("TICKETS") }} ({{ totalNumberOfSeats }} x
                      {{ bookingDetails.ticketprize }})
                    </div>
                    <div>
                      <!-- Tickets -->
                      <!-- <div
                      v-for="(seat,seatIndex) in bookingDetails.seats"
                      :key="seatIndex"
                      class="mb-3"
                      >({{seat.seat_class_title}} x {{seat.seat_count}})</div>-->
                      <div
                        v-if="bookingDetails.student_discount > 0"
                        class="mb-3"
                      >
                        {{ $t("STUDENT_PROMOTION") }} ({{
                          bookingDetails.promotioncount
                        }}
                        x {{ bookingDetails.ptdvalue }})
                      </div>
                      <div v-if="bookingDetails.glassamount > 0" class="mb-3">
                        {{ $t("3D_GLASSES") }}
                        <img
                          v-if="
                            bookingDetails.glassInfoHover &&
                              bookingDetails.glassInfoMessage != ''
                          "
                          v-b-tooltip.hover
                          :title="bookingDetails.glassInfoMessage"
                          src="@/assets/img/svg/icons8-info.svg"
                          height="15px"
                          width="15px"
                          alt="icon-info"
                        />
                      </div>
                      <div class="mb-3">{{ $t("SERVICE_CHARGES") }}</div>
                      <div class="mb-3">{{ $t("VAT_CHARGES") }}</div>
                      <div v-if="promoApplied" class="text-success">
                        <p v-if="promoCode.tab != 'Referral'">
                          <button
                            @click="onRemovedPromocode()"
                            class="btn-delete"
                          ></button>
                          {{ promoCode.selected.Name }}
                        </p>
                        <p v-else>
                          <button
                            @click="onRemoveReferralPromotion()"
                            class="btn-delete"
                          ></button>
                          {{ $t("REFERRAL") }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="lh-1">
                    <div class="text-muted small mb-3 font-weight-bold">
                      {{ $t("AMOUNT") }}
                    </div>
                    <div class="text-right mb-3">
                      {{ bookingDetails.currency }} {{ bookingDetails.amount }}
                    </div>
                    <div
                      v-if="bookingDetails.student_discount > 0"
                      class="mb-3"
                    >
                      -{{ bookingDetails.currency }}
                      {{ bookingDetails.student_discount }}
                    </div>
                    <div
                      v-if="bookingDetails.glassamount > 0"
                      class="text-right mb-3"
                    >
                      <!-- <a @mouseover="onHoverIn(bookingDetails.glassInfoHover)" @mouseleave="onHoverOut(bookingDetails.glassInfoHover)">



                      <div v-if="glassInfoHoverCheck && bookingDetails.glassInfoMessage != ''" class="new-tooltip">
                        <div class="d-flex">
                            <div class="text-nowrap pb-2">{{bookingDetails.glassInfoMessage}}</div>
                        </div>
                      </div>
                      </a>-->
                      {{ bookingDetails.currency }}
                      {{ bookingDetails.glassamount }}
                    </div>
                    <div class="text-right mb-3">
                      {{ bookingDetails.currency }}
                      {{ bookingDetails.service_charges }}
                    </div>
                    <div class="text-right mb-3">
                      {{ bookingDetails.currency }}
                      {{ bookingDetails.vat_charges }}
                    </div>

                    <div
                      v-if="promoApplied"
                      class="text-right mb-3 text-success"
                    >
                      -
                      {{ parseInt(bookingDetails.DiscountValue) }}
                    </div>
                  </div>
                </div>
                <!--<div v-if="this.SelectedReferralCode.length > 0" class="row mb-2">
                <div class="col-md-12 col-sm-12 col-12" v-for="(item, index) in this.SelectedReferralCode">
                  <div class="row">
                    <div class="col-md-2 col-sm-2 col-2"><button @click="onRemovedPromocode()" class="btn-delete"></button></div>
                    <div class="col-md-6 col-sm-6 col-6">{{ item.Name }}</div>
                    <div class="col-md-4 col-sm-4 col-4"><div class="text-right">-KES {{  item.ID }}</div></div>
                  </div>
                </div>
                </div>-->
                <div
                  v-if="
                    bookingDetails.PromotionTextOne != '' &&
                      bookingDetails.PromotionTextOne != 'MTVAL' &&
                      bookingDetails.student_discount <= 0
                  "
                  class="row mb-2"
                >
                  <div class="col-md-6 col-sm-6 col-6">
                    {{ bookingDetails.PromotionTextOne }}
                  </div>
                  <div class="col-md-6 col-sm-6 col-6">
                    <div class="text-right">
                      - {{ Currency }}
                      {{ bookingDetails.PromotionTextOneValue }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="this.foodAndBeverages.selected.length > 0 && checkFnB"
                  class="row mb-2"
                >
                  <div class="col-md-12 col-sm-12 col-12">
                    <u>Food & Beverages</u>
                    <a
                      style="color: #0000ee; margin-top: 8px; cursor: pointer"
                      title="Remove F&B Items"
                      class
                      @click="skipFnB()"
                    >
                      <img
                        style="width: 15px; margin-left: 10px"
                        src="@/assets/img/svg/icon-delete.svg"
                      />
                    </a>
                  </div>
                  <div class="col-md-12 col-sm-12 col-12">
                    <div class="row">
                      <div class="col-md-6 col-sm-6 col-6">Items</div>
                      <div class="col-md-2 col-sm-2 col-2">Qty</div>
                      <div class="col-md-4 col-sm-4 col-4">
                        <div class="text-right">Amount</div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div
                    class="col-md-12 col-sm-12 col-12"
                    v-for="(item, index) in this.foodAndBeverages.selected"
                    :key="index + 'Custom'"
                  >
                    <div class="row">
                      <div class="col-md-6 col-sm-6 col-6">
                        {{ item.ItemName }}
                      </div>
                      <div class="col-md-2 col-sm-2 col-2">{{ item.Qty }}</div>
                      <div class="col-md-4 col-sm-4 col-4">
                        <div class="text-right">
                          {{ Currency }} {{ item.Qty * item.TotalAmount }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--<div class="col-md-12 col-sm-12 col-12">
                  <div class="row">
                    <div class="col-md-6 col-sm-6 col-6"></div>
                    <div class="col-md-6 col-sm-6 col-6 text-right"><a
                      style="color:#0000EE; margin-top: 8px;cursor: pointer;" class="" @click="skipFnB()">Remove</a></div>
                  </div>
                  </div>-->
                </div>
                <!-- <div
                  v-if="!promoApplied && isPromo && isUserLoggedIn"
                  class="row mb-2"
                >
                  <div class="col-md-6 col-sm-6 col-6">
                    Offers and Discounts
                  </div>
                  <div class="col-md-6 col-sm-6 col-6">
                    <a class="applybutton" @click="showApplyCouponModal"
                      >Apply</a
                    >
                  </div>
                </div> -->
                <div class="totalAmount mb-3">
                  <h6 class="text-pink">{{ $t("AMOUNT_PAYABLE") }}</h6>
                  <h6>
                    <span class="mr-1">{{ bookingDetails.currency }}</span>
                    {{ bookingDetails.total_amt }}
                  </h6>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <div
                  class="text-pink text-center mt-3"
                  style="font-size: 18px; font-weight: bold"
                >
                  {{ $t("THIS_SESSION_WILL_EXPIRE") }}
                </div>
                <div
                  class="
                    countdown
                    mt-3
                    d-flex
                    justify-content-center
                    align-items-center
                    mx-auto
                  "
                >
                  <!-- <div class="countdown-circle"></div> -->
                  <div>
                    <div>{{ timer.minutes }} : {{ timer.seconds }}</div>
                  </div>
                </div>
                <!-- <div class="countdown mt-3 d-flex justify-content-center align-items-center mx-auto">
                                      <div>
                                        <div class="countdown-circle">
                                          <span>{{ timer.minutes }} : {{ timer.seconds }} left</span>

                                        </div>
                                      </div>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- THIS IS NEW FOOTER FINAL -->
    <div class="d-md-block">
      <section
        class="detailHeader"
        v-if="sectionName.detailFooter"
        :class="isRTL ? 'rtl' : ''"
      >
        <div class="detailHeader-content">
          <div>
            <router-link @click.native="onClickBackButton()" to>
              <img
                src="@/assets/img/icons/chevron-left.svg"
                height="18px"
                width="18px"
              />
            </router-link>
          </div>

          <div class="header-content">
            <div>
              {{ cinemaDetails.MovieTitle }} ({{ movieDetails.rated }}) |
              {{ cinemaDetails.Name }}
            </div>
            <div>
              {{ showDate.date }} {{ showDate.month }} {{ showDate.year }},
              {{ SchTime }}
            </div>
          </div>
        </div>
        <div
          v-if="totalNumberOfSeats && totalNumberOfSeats > 0"
          v-b-modal.seat_select_modal
          class="no-tickets-header"
        >
          <span>{{ totalNumberOfSeats }} Tickets</span>
          <span>
            <img
              src="@/assets/img/icons/chevron-left.svg"
              height="18px"
              width="18px"
              class="icon"
            />
          </span>
        </div>
      </section>
      <section
        v-if="sectionName.detailFooter && selectedSeats.length > 0"
        class="detailFooter"
        :class="isRTL ? 'rtl' : ''"
      >
        <div class="detailFooter-content">
          <div class="">
            <div class="flex-1">
              <div>
                {{ totalNumberOfSeats }} Tickets x {{ Currency }}
                {{ singleTicketPrice }}
              </div>
              <!-- x BHD 4.5 -->
              <div class="primary-color">
                {{ Currency }} {{ totalAmount.toFixed(2) }}
              </div>
            </div>
            <div
              class="flex-1"
              :class="
                (selectedSeats.length > 0 && selectedSeats.length < 5) ||
                getSeatLayout == false
                  ? ''
                  : selectedSeats.length > 5
                  ? ''
                  : ''
              "
            >
              <div>{{ $t("SEATS_SELECTED") }}</div>
              <div v-if="getSeatLayout == true">
                <ul
                  class="list-inline seats-selected"
                  :class="selectedSeats.length > 0 ? 'mb-0' : 'mb-4'"
                >
                  <span
                    v-for="(seats, seatKey) in selectedSeats"
                    :key="seatKey"
                    class="list-inline-item primary-color"
                    >{{ seats.SeatName }}</span
                  >
                </ul>
              </div>
              <div v-else>{{ $t("OPEN_SEATING") }}</div>
            </div>
          </div>

          <div
            :class="
              this.totalNumberOfSeats == this.selectedSeats.length
                ? 'navProceed'
                : 'navProceedDisabled pointer-none'
            "
            :style="isRTL ? 'gap:10px' : 'gap:10px'"
          >
            <router-link
              v-if="sectionName.noOfSeats"
              v-on:click.native="confirmNumber()"
              to="#"
              :class="totalNumberOfSeats > 0 ? '' : 'pointer-none'"
              class="font-weight-bold text-white mr-2"
              >{{ $t("PROCEED") }} TO {AY}</router-link
            >
            <router-link
              v-if="sectionName.seatLayout"
              v-on:click.native="onSeatConfirmaton()"
              to="#"
              :class="
                totalNumberOfSeats && selectedSeats.length == totalNumberOfSeats
                  ? ''
                  : 'pointer-none'
              "
              class="font-weight-bold text-white"
              >{{ $t("PROCEED") }} TO PAY</router-link
            >
          </div>
        </div>
      </section>
    </div>

    <!-- OTP Modal -->
    <b-modal ref="OTPModal" hide-header hide-footer centered>
      <button
        type="button"
        @click="onCloseModal('OTPModal')"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto">
        <div class="modal-title">Welcome to Wanasa</div>
        <div class="text-danger my-2 text-center">
          {{ ProcessPaymentMessage }}
        </div>
        <form data-vv-scope="VerifyOTP" onsubmit="event.preventDefault()">
          <label>- ENTER OTP -</label>

          <input
            name="OTP"
            type="number"
            v-validate="'required'"
            placeholder="OTP"
            v-model="OTP"
          />
          <span v-show="errors.has('VerifyOTP.OTP')" class="help is-danger">{{
            errors.first("VerifyOTP.OTP")
          }}</span>

          <input @click="confirmBooking()" type="submit" value="VERIFY OTP" />
        </form>
      </div>
    </b-modal>
    <!-- HURRY UP MODAL -->
    <b-modal
      ref="hurryupmodal"
      id="hurryupmodal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <div class="modal-title">{{ $t("HURRY_UP") }}</div>
      <div class="text-center text-black mt-3 mt-md-0">
        {{ $t("BOOKING_EXPIRED") }}
      </div>
      <div class="text-center my-3">
        <button v-on:click="onCloseModal('hurryupmodal')" class="ticketak-btn">
          OK
        </button>
      </div>
    </b-modal>

    <!-- Offer Popup MODAL -->
    <b-modal
      ref="offermodal"
      id="offermodal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <div class="modal-title">DISCOUNT APPLIED!</div>
      <div class="text-center text-white mt-3 mt-md-0 p2">
        Discount of {{ Currency }} {{ bookingDetails.PromotionTextOneValue }} is
        auto applied on your transaction. Proceed to Payment
      </div>
      <div class="text-center my-3">
        <button v-on:click="onCloseModal('offermodal')" class="ticketak-btn">
          OK
        </button>
      </div>
    </b-modal>

    <b-modal
      ref="redirectPayment"
      id="redirectPayment"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <!-- <div class="modal-title">HURRY UP!</div> -->
      <div class="text-center text-white mt-3 mt-md-0 pt-4 px-5">
        Redirecting you to the payment gateway...
        <br />Please click on <b>'Confirm'</b> button once the payment process
        is done, to get your ticket
      </div>
      <div class="text-center my-3">
        <button v-on:click="onclickok()" class="ticketak-btn">
          {{ $t("PROCEED") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      ref="couponNotAllowed"
      id="couponNotAllowed"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <!-- <div class="modal-title">HURRY UP!</div> -->
      <div class="text-center text-white mt-3 mt-md-0 pt-4 px-5">
        {{ promotionNotAllowed }}
      </div>
      <div class="text-center my-3">
        <button v-on:click="couponNotAllowedHide()" class="ticketak-btn">
          Okay
        </button>
      </div>
    </b-modal>

    <!-- TIMEOUT MODAL -->
    <b-modal
      ref="sessionTimeOut"
      id="sessionTimeOut"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <div class="modal-title">{{ $t("SESSION_EXPIRED") }}</div>
      <div class="text-center text-black mt-3 mt-md-0">
        {{ $t("SORRT_TIMEOUT") }}.
      </div>
      <div class="text-center my-3">
        <button v-on:click="onClickRestart()" class="ticketak-btn">
          {{ $t("START_AGAIN") }}
        </button>
      </div>
    </b-modal>

    <!-- QUIT BOOKING MODAL -->
    <b-modal
      id="showquitbookingModal"
      ref="showquitbookingModal"
      title="Quit Booking?"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
    >
      <div class="col-sm-9 col-md-10 mx-auto">
        <div class="modal-title">Quit Booking?</div>

        <div class="mb-4">
          <label class="text-white text-center"
            >Are you sure you want to quit booking?</label
          >
          <div class="text-center my-3">
            <button v-on:click="onClickGoBack()" class="ticketak-btn mt-1 my-1">
              Yes
            </button>
            <button
              @click="onCloseModal('showquitbookingModal')"
              class="ticketak-btn mt-1 my-1"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- ApplyCoupon -->
    <b-modal
      id="applycoupon"
      ref="applycouponModal"
      title="Apply Promotion"
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <button
        type="button"
        @click="onCloseModal('applycouponModal')"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto">
        <div class="modal-title">Apply Promotion</div>

        <div>
          <div class="row mt-3 mb-2">
            <div class="col-md-9 col-sm-12 col-12">
              <input
                type="text"
                v-on:keydown="onKeyUp($event, 'offer')"
                v-model="promoCode.selected.Name"
                placeholder="Enter Voucher Code"
              />
              <div
                v-if="promoCode.errorInputMessage.length > 0"
                class="text-danger"
              >
                {{ promoCode.errorInputMessage }}
              </div>
            </div>
            <div class="col-md-3 col-sm-12 col-12">
              <button class="btn-applyvou mt-2" @click="onApplyPromocode('1')">
                Apply
              </button>
            </div>
          </div>
        </div>

        <div class="base-boundary"></div>

        <div class="mb-4">
          <b-tabs content-class="mt-3">
            <b-tab
              v-for="(tab, tabIndex) in PromotionTabs"
              :key="tabIndex"
              :title="tab"
            >
              <!-- <p> -->
              <!-- <label v-if="promoCode.promoList.length >0" class="text-left">BEST COUPON FOR YOU</label> -->
              <!-- PROMOCODE LOOP -->
              <div
                v-for="(promo, promokey) in promoCode.promoList"
                :key="promokey"
              >
                <div v-if="promo.tab == tab">
                  <div v-if="tab != 'Referral'">
                    <div class="row mt-4">
                      <div class="col-md-6 col-sm-6 col-6">
                        <div class="text-center coupon-code p-2">
                          <span class="font-weight-bold text-white">{{
                            promo.Name
                          }}</span>
                        </div>
                      </div>

                      <div class="col-md-6 col-sm-6 col-6 text-center">
                        <button
                          @click="verifyPromotion(promo, promokey)"
                          class="btn-apply mt-1"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                    <div class="mt-3 text-white">
                      <span class="text-white font-weight-bold">{{
                        promo.ShortDescription
                      }}</span>
                    </div>

                    <div class="mt-2 text-white">
                      <span class>
                        <!-- {{promo.Description}}  -->
                      </span>

                      <span class="font-weight-bold">{{ promo.Expiry }}</span>
                    </div>

                    <div class="text-danger">{{ promo.errorMessage }}</div>
                  </div>
                  <div v-else>
                    <div class="row mt-4">
                      <div class="col-md-6 col-sm-6 col-6">
                        <div class="text-center coupon-code p-2">
                          <span class="font-weight-bold text-white">{{
                            promo.Name
                          }}</span>
                        </div>
                      </div>

                      <div class="col-md-6 col-sm-6 col-6 text-center">
                        <button
                          :disabled="promo.Apply"
                          :class="[
                            'btn-apply',
                            promo.Apply ? 'disable-btn' : 'btn-apply mt-1'
                          ]"
                          @click="verifyPromotion(promo, promokey)"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                    <div class="text-danger">{{ promo.errorMessage }}</div>
                  </div>
                </div>
              </div>
              <div v-if="tab == 'Referral'">
                <button
                  type="button"
                  class="btn-confirm active mt-2"
                  @click="hideReferralModal()"
                >
                  Continue
                </button>
              </div>
              <!-- </p> -->
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>

    <!-- SESSION TIMEOUT  -->
    <!-- <div class="modal-bg" v-if="timer.TimeoutModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content rounded">
          <div class="modal-header">
            <h5 class="modal-title text-center" id="exampleModalLongTitle">
              TIMED OUT
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-light rounded text-center">
            <h1>
              <i class="fas fa-exclamation-triangle text-pink"></i>
            </h1>

            <p>Sorry your session has timed out!</p>

            <p class="text-muted small px-3">
              Sorry, There is a problem with the connectivity at the venue.
              Please try after some time. You could also try calling 022 6144
              5050, 022 3989 5050 to book tickets or if the problem persists
              please write to us at helpdesk@ticketak.com
            </p>

            <a
              v-on:click="restartBooking($event)"
              class="form-control col-8 btn btn-outline-dark"
              >START AGAIN</a
            >
          </div>
        </div>
      </div>
    </div> -->

    <!-- Payment Form -->
    <div style="display: none" id="form_sample"></div>
    <!-- Include JS file here -->

    <!-- MOVIE CHECKOUT MODAL -->
    <div class="modal-bg" v-if="sectionName.typeSelector">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close text-right px-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="col-12 mx-auto">
              <div class="seatPopHdr">
                <div class="row">
                  <div class="col-md-8 col-12 py-md-0 py-5">
                    <div class="seatCol1">
                      <div class="headline pb-4">
                        Select Movie Class Category?
                      </div>
                      <div class="ticktSum">
                        <hr />
                        <div class="seatClass">
                          <div class="fl">
                            <input
                              type="radio"
                              value
                              checked="checked"
                              name="rdbschClass"
                            />
                          </div>
                          <p class="seatTitle">
                            Bachelor
                            <span>(3.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input type="radio" value name="rdbschClass" />
                          </div>
                          <p class="seatTitle">
                            Family
                            <span>(3.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input
                              id="rdbClass87098"
                              type="radio"
                              value
                              name="rdbschClass"
                            />
                          </div>
                          <p class="seatTitle">
                            Premium Bachelor
                            <span>(4.5 KWD)</span>
                          </p>
                        </div>

                        <div class="seatClass">
                          <div class="fl">
                            <input
                              id="rdbClass87099"
                              type="radio"
                              value="87099"
                              name="rdbschClass"
                            />
                          </div>
                          <p class="seatTitle">
                            Premium Family
                            <span>(4.5 KWD)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="p-3">
                      <a href="#" class="btn btn-info w-75">Book Now</a>
                    </div>
                  </div>

                  <div class="col-4 p-0 d-none d-md-block">
                    <div class="seatCol2" id="divSeatSelMovie">
                      <div class="mvD-img">
                        <img
                          src="img/e0c882f0f59849649fc8a2b392d5baeb.jpg"
                          alt
                          class="img-fluid"
                        />
                      </div>
                      <h1>Black Water (15+)</h1>
                      <p class="mvD-type">2D</p>
                      <p class="mvD-type">Action,Drama</p>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">LANGUAGE</p>
                        <p>English</p>
                      </div>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">SUBTITLES</p>
                        <p>English</p>
                      </div>
                      <div class="mvD-typeHdr">
                        <p class="mvD-typeHdr-lg">LENGTH</p>
                        <p>1h 45min</p>
                      </div>
                      <div class="showTime">
                        <h3>
                          <span class="bold">Cinescape</span> : KNCC Test Site
                        </h3>
                        <p>2018-12-24, 19:15</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL FOR SEAT SELECTION AGAIN -->
    <b-modal
      id="seattypesmodal"
      ref="seattypesmodal"
      title="Seat Types"
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div class="select-seat-section">
        <div class="modal-title">{{ $t("PLEASE_SELECT_SEAT_TYPE") }}</div>
        <div class="container px-2 px-md-3">
          <div class="select-seat-container">
            <div>
              <div v-if="OnlySeatType.length > 0" class="mb-4">
                <!-- <h6 class="mb-3">Select the seat type</h6> -->
                <div class="row">
                  <div
                    v-for="(SingleSeatType, SeatKey) in OnlySeatType"
                    :key="SeatKey"
                    class="pr-2"
                    :class="
                      OnlySeatType.length == 1 ? 'col-12' : 'col-' + seatsClass
                    "
                  >
                    <button
                      v-on:click="onNewSelectSeatType(SingleSeatType)"
                      class="btn-rounded h-auto"
                    >
                      {{ SingleSeatType.SeatType }}
                      <br />
                      ({{ Currency }} {{ SingleSeatType.Price }})
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="noseattype"
      id="noseattype"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-title"></div>
      <div class="mx-2">
        <div class="list-group px-4">
          <h3 class="text-center">{{ $t("OOPS") }}</h3>
          <p>
            Seems like there is some issue at cinema end. Please trying again
            after sometime
          </p>
        </div>
      </div>
      <div class="text-center">
        <router-link class="btn-light btn active mb-3 center" to="/"
          >Home</router-link
        >
      </div>
    </b-modal>
    <b-modal
      centered
      no-close-on-esc
      hide-header-close
      ref="scbModal"
      id="scbModal"
      hide-header
      hide-footer
      class="country-modal card-selected"
    >
      <h5 class="text-center card-heading">SCB CARD SELECTED</h5>
      <div class="text-center">
        <h5>Congratulations</h5>
        <p className="my-3">
          You have availed 50% Off on Tickets by using SCB Card.
        </p>
        <div class="d-flex justify-content-between px-2 px-xl-4">
          <div>
            <p>{{ $t("Before Discount") }}</p>
            <p>
              <b>{{ Currency }} {{ bookingDetails.BeforeDiscount }}</b>
            </p>
          </div>

          <div>
            <p>{{ $t("After Discount") }}</p>
            <p>
              <b> {{ Currency }} {{ bookingDetails.PromotionTextOneValue }}</b>
            </p>
          </div>
        </div>
      </div>
      <hr />
      <div class="text-center mx-auto my-2">
        <button
          type="button"
          v-on:click="onClickScbOk()"
          class="btn-confirm active"
        >
          {{ $t("SUBMIT") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { secureStore } from "@/helper/storage";
import { EventBus } from "@/main";
import VueFriendlyIframe from "vue-friendly-iframe";
import { TokenService, CountryService } from "@/services/storage.service";
import { _, groupBy } from "lodash";
import { URL_BASE, EVENT_URL } from "@/helper/constant";
import $ from "jquery";
import { PROJECT, metaInfo } from "@/helper/constant.js";
import { VeeValidate } from "vee-validate";
import { mapGetters } from "vuex";
import Slick from "vue-slick";
import countryCodes from "@/helper/countryCodes.js";

// import VueSnackbar from 'vue-snack'
// Vue.use(VueSnackbar)
Vue.component("vue-friendly-iframe", VueFriendlyIframe);
//import { fromBits } from "long";

// import {
//   // mapActions
//   mapGetters
// } from "vuex";

export default {
  metaInfo: metaInfo,
  components: {
    Slick,
    VuePhoneNumberInput
  },
  props: {
    // allShowTimes: {
    //   type: Array,
    //   default: []
    // }
  },
  head: {
    title() {
      return `Ticketak`;
    },
    meta: [
      {
        name: "description",
        content() {
          return `Here is the description`;
        }
      }
    ]
  },
  //   asyncData({ store, route }) {
  //   },
  data() {
    return {
      payment_options: [],
      SeatErrormessage: "",
      countryList: countryCodes,
      showPaymentCollapse: false,
      get screenWidth() {
        return window.innerWidth >= 767 ? true : false;
      },
      ratingContent: null,
      isValidNumber: false,
      selectedSeatType: "",
      resultsExample: null,
      results: true,
      onUpdate: "",
      phoneNumber: null,
      defaultCountry: "FR",
      valid: true,
      countriesList: [],
      countriesIgnored: [],
      dark: false,
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: true,
      modalTrue: true,
      studentIDs: [],
      studentIDFilter: [],
      paymentBlock: true,
      Discount: {
        isstudentcheck: 0,
        totaldiscountticket: 0,
        totalticketbook: 0,
        studentvaluearray: []
      },
      discountAmount: 0,
      totalDiscountAmount: 0,
      SeatTypeMT: "",
      SelectedSeatType: "",
      myticketDisplaySeatType: "",
      BASEURL: URL_BASE,
      ConfirmationURL: "",
      FailedURL: "",
      MinSeatsFlag: false,
      seatLayoutDateSlider: {
        loop: false,
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 1450,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },

          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      project: PROJECT,
      bankPage: {
        src: ""
      },
      showDate: {
        actualDate: "",
        day: "",
        date: "",
        month: "",
        year: "",
        actualtime: ""
      },
      CountryID: "",
      SchTime: "",
      showOTP: false,
      OTP: "",
      cinemaDetails: {},
      Default: {},
      showDetails: {},
      savedBankPage: {
        src: ""
      },
      timerStartFunction: null,
      conditions: false,
      savecardradio: false,
      studentCheck: false,
      creditCardDetails: {
        number: ["", "", "", ""],
        expiryMonth: "",
        expiryYear: "",
        name: "",
        cvv: "",
        saveCard: true,
        error: ""
      },
      savedCreditCardDetails: {
        error: ""
      },
      isUserLoggedIn: false,
      verifyError: "",
      savedCreditCards: [],
      getSeatLayout: 1,
      backURL: "",
      OTPScreen: false,
      walletResponse: {},
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false
      },
      modal: {
        signIn: false,
        guestLogin: false,
        payment: false, //make false
        payUsingWallet: false,
        userTicketsDetails: false
      },
      paymentModal: {
        editContactDetails: false,
        viewContactDetails: true,
        wallet: false
      },
      selectedCard: {},
      sectionName: {
        seatLayout: true,
        checkout: false,
        confirmation: false,
        foodAndBeverages: false,
        detailFooter: true,
        noOfSeats: false,
        typeSelector: false
      },
      seatData: {},
      SeatType: "",
      selectedSeatName: [],
      numberofSeatsArray: [1, 2, 3, 4, 5, 6, 7, 8],
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      DefaultCountryCode: "",
      totalAmount: 0,
      internetHandling: 10,
      discount: 0,
      movieDetails: {},
      foodAndBeverages: {
        listing: [],
        status: false,
        selected: [],
        allListing: [],
        selectedCategory: "All"
      },
      userDetails: {
        email: "",
        phoneNumber: "",
        password: "",
        countryCode: ""
      },
      signIn: {
        email: "",
        password: "",
        flag: false
      },
      cardError: "",
      loginErrorMessage: "",
      UserIPAddress: {},
      promoApplied: false,
      reservationID: "",
      bookingID: "",
      voucherCode: "",
      VoucherMsg: "",
      voucherApplied: false,
      seatTypes: [],
      SBScreenName: "",
      CountryCodeList: [],
      promoListCopy: [],

      promoCode: {
        message: "",
        selected: {
          Title: "",
          PromotionID: ""
        },
        promoList: [],
        errorMessage: "",
        errorInputMessage: "",
        successMessage: "",
        applied: false,
        tab: ""
      },
      errorMessage: {
        otpError: ""
      },
      walletInfo: {},
      finalBookingID: "",
      bookingDetails: {},
      bookingDetailsCopy: {},
      finalBookingDetails: {},
      bookingTermsAndConditions: null,

      guest: {
        errorMessage: ""
      },
      ProcessPaymentMessage: "",
      newPaymentOptions: [],
      Paymentoptions: {
        wallet: {},
        ExpressPay: {},
        creditCard: {}
      },

      FoodNAMessage: "",
      FoodNAStatus: true,
      IsSeatTypePopup: false,
      fnbtotal: 0,
      fnbQty: 0,
      nbs: "",
      Currency: "",
      movieID: "",
      scheduleID: "",
      movieDetails: {},
      seatLayout: [],
      reserveID: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      status: {
        emailStatus: false,
        phoneNumberStatus: "",
        offer: false
      },
      firstCollapsed: true,
      secondCollapsed: false,
      fnbCollapsed: true,
      OnlySeatType: [],
      isPromoFromList: false,
      isfocus: {
        item0: false,
        item1: false,
        item2: false,
        item3: false
      },
      allShowTimes: [],
      isStudent: false,
      isscb: 0,
      isVoucherApplicable: false,
      glassval: 0,
      langName: "English",
      checkFnB: false,
      checkDiscount: true,
      PromotionTabs: [],
      SelectedReferralCode: [],
      promotionFlag: "Apply",
      promotionNotAllowed: "",
      glassInfoHoverCheck: false,
      offerPopupCheck: true,
      isPromo: false,
      SeatCatWidth: [],

      //
      onErrorMeesage: null
    };
  },

  computed: {
    seatsClass() {
      return Math.round(12 / parseInt(this.OnlySeatType.length));
    },

    ...mapGetters(["isRTL"]),
    phonenumbertrue() {
      if ((this.hasErrorActive = false)) {
        return this.status.phoneNumberStatus;
      }
    },
    checkoutButtonStatus() {
      // console.log("HELLO", this.onErrorMeesage,this.status.emailStatus, this.status.phoneNumberStatus, this.conditions )
      const value =
        !this.onErrorMeesage &&
        this.status.emailStatus &&
        this.status.phoneNumberStatus &&
        this.conditions
          ? true
          : false;

      if (value) {
        this.showPaymentCollapse = false;
      } else {
        this.showPaymentCollapse = false;
      }
      return value;
    },
    checkoutOfferButtonStatus() {
      return this.status.offer ? true : false;
    },
    discountSpace() {},
    finalValue() {
      return (
        parseInt(this.totalAmount) +
        parseInt(this.seatData.ConFee * this.selectedSeats.length) -
        parseInt(this.discount)
      );
    }
  },
  watch: {
    // "showDate.actualtime": function(newVal, oldVal){
    //   console.log('newVal, oldVal', newVal, oldVal);
    // }
    // results:function(val){
    //   this.results=val
    //   console.log(this.results,"from watchers")
    // }
    resultsExample: {
      handler(value) {
        console.log(value);
        this.isValidNumber = value.isValid;
      }
    }
  },

  beforeCreate() {},
  beforeMount() {
    document.addEventListener(
      "DOMContentLoaded",
      function() {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        var ngeniusScript = document.createElement("script");
        script.src = "https://html2canvas.hertzen.com/dist/html2canvas.min.js";
        ngeniusScript.src = Movie;
        ("https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js");
        head.appendChild(script);
        head.appendChild(ngeniusScript);
      },
      false
    );

    this.backURL =
      "/movie-showtimes-page?movieId=" + this.$route.params.movieID;
    this.getIPAddress();
    if (TokenService.getToken()) {
      this.signIn.flag = true;
    }
    this.movieID = this.$route.params.movieID;
    this.scheduleID = this.$route.params.scheduleID;
    this.getSeatLayout = this.$route.params.seatLayout > 0 ? true : false;
    this.totalNumberOfSeats = 1;
    this.ConfirmationURL = window.location.origin + "/confirmation";
    this.FailedURL = window.location.origin + "/failedPayment";
    this.fetchMovieDetails();
    this.getPromotionList();
    this.getSeatType();
    this.getRatingContent(this.movieID);
    /**
     * SaifGetMovieTime
     */
    //
    //
    console.log(" this.scheduleID", this.scheduleID);
  },
  mounted: function() {
    this.getSeatLayoutNew();
    // this.getPaymentOptions();
    this.onErrorMeesage = null;
    //this.createNgeniusCardSection();

    let country = CountryService.getCountry();
    //countryid
    if (!country) {
      this.CountryID = 119;
    } else {
      this.CountryID = country.CountryID;
    }
    this.userDetails.countryCode = country.CountryISOCode;
    //languageid
    window.localStorage.removeItem("ReserveID");
    //network gateway call
    /*let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://network.gateway.mastercard.com/checkout/version/49/checkout.js"
    );
    recaptchaScript.setAttribute(
      "data-error",
      window.location.origin + "/failedPayment"
    );this.results
    recaptchaScript.setAttribute(
      "data-complete",
      window.location.origin + "/PaymentComplete/"
    );
    document.head.appendChild(recaptchaScript);*/

    // if (this.$attrs.props && this.$attrs.props.allShowTimes) {
    //   this.allShowTimes = this.$attrs.props.allShowTimes;
    // }

    // this.getScheduleSeatClasses();
    // this.getPromoCodes();
    this.getAllGetCountryList();
    EventBus.$on("onProfileSuccess", () => {
      this.getUserDetails();
    });

    EventBus.$on("paymentCompletionEvent", user => {
      this.paymentConfirmation();
    });
    window.addEventListener("message", function(e) {
      if (e.data === "sb:bn:loaded") {
        console.log("eventworking", e);
        EventBus.$emit("paymentCompletionEvent", e);
      }
    });

    //
  },
  methods: {
    onClickScbOk() {
      this.$refs.scbModal.hide();
    },
    async getRatingContent(MovieID = "") {
      let payload = { MovieID };
      console.log("rating=>>>>>>", MovieID);
      let { error, res } = await makeRequest(
        "/GetRatingContent",
        "POST",
        null,
        payload
      );
      if (!error && res.data && res.data.Status && res.data.Data) {
        this.ratingContent = res.data.Data;

        if (this.ratingContent) {
          // this.$refs.tncModal && this.$refs.tncModal.show()
        }
      } else {
        console.error({ error });
        this.$refs.tncModal && this.$refs.tncModal.hide();
      }
    },
    getPaymentName(payOption) {
      if (payOption.payment_id == "3") {
        this.$refs.scbModal.show();
        this.isscb = 1;
        this.getReservesDetails();
      } else {
        this.isscb = 0;
        this.getReservesDetails();
      }
    },
    getPaymentOptions() {
      this.showLoading();
      if (this.reserveID) {
        makeRequest(
          `/v1/payment?reserve_id=${this.reserveID}`,
          "GET",
          null,
          null,
          EVENT_URL
        )
          .then(response => {
            const { error, res } = response;
            console.log(res, error);

            if (!error) {
              this.payment_options = res.data.data;
              this.showPaymentCollapse = true;
              setTimeout(() => {
                let elmnt = document.getElementById("payment-mode-section");
                elmnt.scrollIntoView({ behavior: "smooth", inline: "start" });
              }, 0);
              this.hideLoading();
            } else {
              console.log("Response Error ");
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
        this.hideLoading();
      }
    },
    sessionExpired() {
      let payload = {
        ReserveID: this.reserveID
      };
      makeRequest("/BookingReserveDisable", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          const { data } = res.data;
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },

    onCountryChange() {},
    onUpdate(payload) {
      this.status.phoneNumberStatus = payload.isValid;
      console.log("gsdgasddgasjhah", this.status.phoneNumberStatus);
    },
    showRatedModal() {
      this.$refs.rated_modal && this.$refs.rated_modal.show();
    },
    hideRatedModal() {
      this.$refs.rated_modal && this.$refs.rated_modal.hide();
      this.showSeatNoModal();
    },
    showSeatNoModal() {
      this.$refs.tncModal && this.$refs.tncModal.show();
    },
    onClickSeatSelectionModal() {
      this.$refs.tncModal && this.$refs.tncModal.hide();
      this.$refs.seat_select_modal && this.$refs.seat_select_modal.show();
    },
    onCancelRedirectBack() {
      history.back();
    },
    hideSeatNoModal() {
      this.$refs.seat_select_modal && this.$refs.seat_select_modal.hide();
    },
    onShowSeatImg(number) {
      this.totalNumberOfSeats = number;
    },
    onSelectNumberOfSeats(number) {
      this.selectedSeats.map(x => {
        this.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
        this.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
      // this.seatLayout.map(seatRow => {
      //   seatRow.map(seat => {
      //     seat.SelectStatusFlag = false;
      //     seat.SelectStatus = false;
      //   });
      // });
      //   this.selectedSeats = [];
      if (this.cinemaDetails.Name.includes("Novo")) {
        this.getSeatLayoutNew();
      }

      this.hideSeatNoModal();
    },

    getCinemaMovieTimes: function(payload) {
      this.allShowTimes = [];
      makeRequest("/GetCinemaSchedule", "POST", null, payload)
        .then(async response => {
          const { error, res } = response;
          if (
            !error &&
            res.data &&
            res.data["Data"] &&
            res.data.Data.length > 0
          ) {
            console.log("res.data.Data", res.data.Data);
            // this.allShowTimes = res.data.Data;
            // this.allcinemas = res.data.Data;
            // this.allcinemas.push({ name: "All Cinemas" });
            // // this.selectedCinema = this.allcinemas[0].name;
            this.allShowTimes = res.data.Data[0].timings.map(x => {
              x["ShowTime"] = x.time;
              x["SchID"] = x.id;
              x["Format"] = x.format;
              return x;
            });
            await Promise.all(this.allShowTimes);
            console.log(" this.allShowTimes", this.allShowTimes);
            // console.log(
            //   "this.$refs.cinemaMovieTimeSlick",
            //   this.$refs.cinemaMovieTimeSlick
            // );
            // this.$refs.cinemaMovieTimeSlick.destroy();
            // this.$nextTick(() => {
            //   this.$refs.cinemaMovieTimeSlick.create();
            // });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    closeModal() {
      this.modalTrue = false;
    },
    ///
    createNgeniusCardSection() {
      /* Method call to mount the card input on your website */
      window.NI.mountCardInput("mount-id" /* the mount id*/, {
        style: {
          main: {
            margin: "0px",
            padding: "0px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          base: {
            fontSize: "16px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          input: {
            borderWidth: "1px",
            borderRadius: "5px",
            borderStyle: "solid",
            backgroundColor: "#FFFFFF",
            borderColor: "#DDDDDD",
            color: "#000000",
            padding: "5px",
            fontUrl:
              "https://fonts.googleapis.com/css?family=Odibee+Sans&display=swap",
            fontFamily: "Odibee Sans !important"
          },
          invalid: {
            borderColor: "red"
          }
        }, // Style configuration you can pass to customize the UI
        /*apiKey : 'ZDJkOGJlY2EtYzBiZS00MTQ1LWFiZjYtYzg1MjVlODUxMGI3OjM2NDgyZWRmLTM1NmEtNGRlYy04YjcwLWE4ZTUzMTA5NzljMg==', // API Key for WEB SDK from the portal
                 outletRef : '5edab6d7-5946-43f4-b8c7-06b29c272bdd', // outlet reference from the portal
                 */

        //UAT

        apiKey:
          "YWJjMjQyZDEtZWJlMC00NDc1LTlkMmItMWY3Y2ZmYWY0MGFkOjFmMmRlNWY2LTM1NTYtNDU3Yi05ZDVhLTExMGQ4MTU5M2ViNg==", // API Key for WEB SDK from the portal
        outletRef: "e209b88c-9fb6-4be8-ab4b-e4b977ad0e0d", // outlet reference from the portal

        //Live
        /*apiKey:
          "YTJjZTg2ZWMtMzMwMi00MWE2LWFlZmMtOWEyZjQ5YWIzYTI4OjYyMjYzYjlhLTM0NDUtNDVkZS1iOGFiLWNkOTAxZGE0YWRkZA==", // API Key for WEB SDK from the portal
        outletRef: "16dd685a-7139-4b10-a821-7bede1070010", // outlet reference from the portal*/

        onSuccess: "", // Success callback if apiKey validation succeeds
        onFail: "", // Fail callback if apiKey validation fails
        onChangeValidStatus: ({
          isCVVValid,
          isExpiryValid,
          isNameValid,
          isPanValid
        }) => {
          console.log(isCVVValid, isExpiryValid, isNameValid, isPanValid);
        }
      });
    },
    payNowNetowrk: function() {
      this.showLoading();
      let payload = {
        ReserveID: this.reserveID,
        ctoken: 1110266398,
        Email: this.userDetails.email,
        Number: this.userDetails.phoneNumber,
        countrycode: this.DefaultCountryCode
      };
      makeRequest("/ReserveDetailsNew", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.hideLoading();
            console.log(res.data);
            //this.bankPage.src = res.data.order_paypage_url;
            this.sectionName.foodAndBeverages = false;
            window.location.href = res.data.order_paypage_url;
            //window.open(res.data.order_paypage_url, '_blank');
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    checkingOnPaymentCall: function() {
      let self = this;
      // console.log("Here we area calling", Checkout);
      Checkout.configure({
        merchant: "001110266368",
        session: {
          id: self.bookingDetails.SessionID
          // id: "SESSION0002304652986E8327415I86"
        },
        order: {
          amount: function() {
            return parseFloat(self.bookingDetails.total_amt);
            // return 1;
          },
          currency: "AED",
          description: "Ordered goods",
          id: "TCK0" + self.reserveID
        },
        interaction: {
          merchant: {
            name: "Rasikh Portal LLC ",
            address: {
              line1: "200 Sample St",
              line2: "1234 Example Town"
            },
            email: "support@ticketak.com"
          }
        }
      });

      //HARDCODEED
      // Checkout.configure({
      //   merchant: "001110266368",
      //   session: {
      //     id: "SESSION0002304652986E8327415I86"
      //   },
      //   order: {
      //     amount: function() {
      //       return 169.5;
      //     },
      //     currency: "AED",
      //     description: "Ordered goods",
      //     id: "TCK014399"
      //   },
      //   interaction: {
      //     merchant: {
      //       name: "Rasikh Portal LLC ",
      //       address: {
      //         line1: "200 Sample St",
      //         line2: "1234 Example Town"
      //       },
      //       email: "support@ticketak.com"
      //     }
      //   }
      // });
      Checkout.showLightbox();
    },
    handler: function(e) {
      //do stuff
      e.preventDefault();
    },
    onClickSignModal: function() {
      this.$root.$emit("bv::show::modal", "signIn");
    },
    addhyphen: function(params) {
      return params.replace(/\s+/g, "-");
    },
    openModal: function() {
      this.$refs.hurryupmodal.show();
    },
    onCloseModal: function(name) {
      this.$refs[name].hide();
    },
    onClickGoBack: function() {
      this.$router.go(-1);
    },
    onClickShowTime: function(showTime) {
      this.scheduleID = showTime.SchID;
      this.seatData = {};
      this.seatLayout = [];
      // this.SeatType = "";
      this.seatTypes = [];
      this.selectedSeats = [];
      this.totalAmount = 0;
      this.SchTime = showTime.ShowTime;
      // Saif Get Seat Types and Show Modal
      if (this.project == "myticketi") {
        this.getTempSeatType();
      } else {
        this.getSeatLayoutNew();
      }
    },
    onClickRestart() {
      this.$refs.sessionTimeOut.hide();
      this.timer.minutes = 9;
      this.timer.seconds = 59;
      this.timer.stop = false;
      this.$router.go(this.$router.fullPath);
      //reset data
      this.cinemaId = {};
      this.selectedCard = {};
      this.seatData = {};
      this.SeatType = "";
      this.numberOfSeatsSelected = 0;
      this.totalNumberOfSeats = 0;
      this.selectedSeats = [];
      this.totalAmount = 0;
      this.singleTicketPrice = 0;
      this.discount = 0;
      this.promoApplied = false;
      this.isPromoFromList = false;
      this.reservationID = "";
      this.bookingID = "";
      this.seatTypes = [];
      this.promoCode.message = "";
      this.promoCode.selected.Title = "";
      this.promoCode.selected.PromotionID = "";
      this.promoCode.selected.Name = "";

      this.promoCode.promoList = [];
      this.promoCode.errorMessage = "";
      this.promoCode.errorInputMessage = "";
      this.promoCode.successMessage = "";
      this.promoCode.applied = false;
      this.bookingDetails = {};
      this.bookingDetailsCopy = {};
      this.bookingTermsAndConditions = null;
      this.finalBookingDetails = {};
      this.seatLayout = [];
      this.reserveID = "";
      this.OnlySeatType = [];
      this.getSeatType();
      this.getPromotionList();
      //
      this.sectionName.seatLayout = false;
      this.sectionName.checkout = false;
      this.sectionName.confirmation = false;
      this.sectionName.detailFooter = true;
      this.sectionName.noOfSeats = true;
      this.sectionName.typeSelector = false;
    },
    onHoverIn: function(glassInfoHover) {
      console.log(glassInfoHover);
      this.glassInfoHoverCheck = true;
    },
    onHoverOut: function(glassInfoHover) {
      console.log(glassInfoHover);
      this.glassInfoHoverCheck = false;
    },
    onHover: function(glassInfoHover) {
      console.log(glassInfoHover);
      if (glassInfoHover) {
        this.glassInfoHoverCheck = true;
        this.bookingDetails.glassInfoHover = false;
      } else {
        this.glassInfoHoverCheck = false;
        this.bookingDetails.glassInfoHover = true;
      }
    },
    CCOnKeyUp: function(item, type, e, card) {
      //for cvv
      if (type == "cvv") {
        if (card) {
          this.selectedCard = card;
        }

        if (this.creditCardDetails.cvv.length > 3) {
          this.creditCardDetails.cvv = this.creditCardDetails.cvv.slice(0, -1);
          this.$refs.cvv.blur();
        }
      }
      //for year and month
      if (type == "expiry") {
        if (
          this.creditCardDetails.expiryMonth.length == 2 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(
            0,
            -1
          );
          this.$refs.cvv.focus();
        }
        // if (this.creditCardDetails.expiryYear.length == 0 && item == 2) {
        //   this.$refs["expiry1"].focus();
        // }
      }
      // expiryYear
      if (type == "expiryYear") {
        if (
          this.creditCardDetails.expiryMonth.length == 2 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(
            0,
            -1
          );
          this.$refs.cvv.focus();
        }
      }
      //for number
      if (type == "number") {
        let temp = "item" + item;
        let focusVal = this.isfocus[temp];
        if (
          this.creditCardDetails.number[item].length == 0 &&
          item != 0 &&
          !focusVal
        ) {
          let value = "card" + (item - 1);
          this.$refs[value].focus();
        }
        if (this.creditCardDetails.number[item].length > 4) {
          this.creditCardDetails.number[item] = this.creditCardDetails.number[
            item
          ].slice(0, -1);
        }
        if (
          this.creditCardDetails.number[item].length == 4 &&
          e.keyCode < 58 &&
          e.keyCode > 47
        ) {
          if (item == 3) {
            this.$refs["cardName"].focus();
            return;
          }
          let value = "card" + (item + 1);
          this.$refs[value].focus();
        }
      }
    },
    onClickBackButton: function() {
      if (this.sectionName.noOfSeats == true) {
        this.$router.go(-1);
      } else if (this.sectionName.seatLayout == true) {
        this.$router.go(-1);
      }
    },
    onKeyUp: function(event, name) {
      this.showPaymentCollapse = false;
      this.onErrorMeesage = null;
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (name == "email") {
        this.status.emailStatus = emailreg.test(this.userDetails.email);
        ///check email validation
      } else if (name == "mobile") {
        this.userDetails.countryCode = event.countryCallingCode;
        // this.userDetails.phoneNumber = this.userDetails.phoneNumber.replace(
        //   /\./g,
        //   ""
        // );
        // let passwordRege = /\d{9}/;
        // this.status.phoneNumberStatus = passwordRege.test(
        //   this.userDetails.phoneNumber
        // );
        console.log(event);
        if (event.isValid) {
          this.status.phoneNumberStatus = true;
        } else {
          this.status.phoneNumberStatus = false;
        }
        //check mobile validation
      }
      if (name == "offer") {
        // this.promoCode.selected.Title = event.value;
        if (this.promoCode.selected.Name.length > 0) {
          this.status.offer = true;
          this.promoCode.errorInputMessage = "";
        } else if (this.promoCode.selected.Name.length == 0) {
          this.status.offer = false;
        }
      }
      if (name == "studentCheck") {
        if (!this.promoApplied) {
          this.studentIDs = [];
          this.promotionDiscount();
        } else {
          event.preventDefault();
          this.studentCheck = false;
          this.promotionNotAllowed = "You have already applied for a coupon.";
          this.$refs.couponNotAllowed.show();
        }
      }
    },
    onApplyPromocode: function(type) {
      this.showLoading();
      this.VoucherMsg = "";
      // this.promoCode.promoList = this.promoCode.promoListCopy;
      // if (this.promoListCopy.length > 0) {
      //   for (var i = 0; i < this.promoListCopy.length; i++) {
      //     if (
      //       this.promoListCopy[i].Name.toLowerCase() ==
      //       this.promoCode.selected.Name.toLowerCase()
      //     ) {
      this.verifyPromotion(type);
      //     } else {
      //       this.bookingDetails = this.bookingDetailsCopy;
      //       this.promoCode.errorInputMessage = "Not a Valid Coupon";
      //       this.promoApplied = false;
      //     }
      //   }
      // } else {
      //   this.promoCode.errorInputMessage = "Not a Valid Coupon";
      // }

      // this.promoListCopy.map((x, index) => {
      //   if (
      //     this.promoCode.selected.Name.toLowerCase() === x.Name.toLowerCase()
      //   ) {
      //     this.verifyPromotion(x, index);
      //   } else {
      //     this.bookingDetails = this.bookingDetailsCopy;
      //     this.promoCode.errorInputMessage = "Not a Valid Coupon";
      //     this.promoApplied = false;
      //   }
      // });
    },
    promotionDiscount: function() {
      //this.discountAmount
      this.totalDiscountAmount = 0;
      this.bookingDetails.glassamount = parseInt(0);
      this.bookingDetails.ptdvalue =
        this.bookingDetails.ticketprize - this.discountAmount;
      this.bookingDetails.promotioncount = 0;
      var enteredIDCount = 0;
      var balanceGlassAmount = 0;
      console.log("onblur called :", this.bookingDetails.ptdvalue);
      for (var i = 1; i < this.studentIDs.length; i++) {
        console.log("this.studentIDs[i] :", this.studentIDs[i]);
        if (this.studentIDs[i] != "") {
          this.totalDiscountAmount +=
            this.bookingDetails.ticketprize - this.discountAmount;
          this.bookingDetails.promotioncount = parseInt(
            this.bookingDetails.promotioncount + 1
          );
          if (this.glassval > 0) {
            this.bookingDetails.glassamount += parseInt(this.glassval);
          }
          enteredIDCount += 1;
        }
      }

      var studentIDCount =
        this.totalNumberOfSeats - parseInt(this.studentIDs.length - 1);
      for (var j = 0; j < this.totalNumberOfSeats; j++) {
        if (this.glassval > 0) {
          balanceGlassAmount += parseInt(this.glassval);
        }
      }
      if (this.glassval > 0) {
        this.bookingDetails.glassamount =
          balanceGlassAmount - parseInt(this.bookingDetails.glassamount);
      }
      this.bookingDetails.student_discount = this.totalDiscountAmount;
      this.bookingDetails.total_amt = parseInt(
        this.totalNumberOfSeats * this.bookingDetails.ticketprize -
          this.bookingDetails.student_discount +
          parseInt(
            this.totalNumberOfSeats * this.bookingDetails.internet_handling_amt
          ) +
          parseInt(this.bookingDetails.glassamount) +
          parseInt(this.bookingDetails.fnb_total)
      );
      this.checkDiscount = false;
      console.log(this.checkDiscount);
    },
    getAllGetCountryList: function() {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.List;
            this.DefaultCountryCode =
              res.data.Default.CountryCode || res.data.List.length
                ? res.data.List[3].CountryISOCode
                : "";
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onChangeCountry: function(country) {
      this.DefaultCountryCode = country.CountryISOCode;
    },
    onclickAdd: function(index) {
      this.OnlySeatType = this.OnlySeatType.map((x, seatIndex) => {
        if (this.OnlySeatType.length == 1) {
          this.SeatTypeMT = x.SeatLabel;
          if ((seatIndex == index && x.count < 10) || x.isuniqueSeat) {
            this.SeatTypeMT = x.SeatLabel;
            x.count++;
          } else {
            x["clickDisabled"] = true;
          }
        } else {
          if (seatIndex == index && x.count < 10 && x.isuniqueSeat) {
            this.SeatTypeMT = x.SeatLabel;
            x.count++;
          } else {
            x["clickDisabled"] = true;
          }
        }
        return x;
      });
      this.totalNumberOfSeats = 0;
      this.OnlySeatType.filter(x => {
        this.totalNumberOfSeats += x.count;
      });
      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.OnlySeatType.filter(x => {
        if (x.count > 0) {
          if (x.count >= x.seatqty) {
            this.MinSeatsFlag = true;
          }
          this.singleTicketPrice = x.Price;
          this.totalAmount += parseFloat(x.Price * x.count);
        }
      });
    },
    onclickSubtract: function(index) {
      var checkSeatZero = false;
      this.OnlySeatType = this.OnlySeatType.map((x, seatIndex) => {
        if (seatIndex == index && x.count > 0) {
          x.count--;
          if (x.count == 0) {
            x["clickDisabled"] = false;
            checkSeatZero = true;
          }
        }
        return x;
      });

      if (checkSeatZero) {
        this.OnlySeatType = this.OnlySeatType.map((x, seatIndex) => {
          x["clickDisabled"] = false;
          return x;
        });
      }
      this.totalNumberOfSeats = 0;
      this.OnlySeatType.filter(x => {
        this.totalNumberOfSeats += x.count;
      });
      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.OnlySeatType.filter(x => {
        if (x.count > 0) {
          if (x.count < x.seatqty) {
            this.MinSeatsFlag = false;
          }
          this.singleTicketPrice = x.Price;
          this.totalAmount += parseFloat(x.Price * x.count);
        }
      });
    },
    onNewSelectSeatType(type) {
      console.log("type", type);

      // this.showSeatNoModal();
      this.SeatType = type;
      this.SeatTypeMT = type;
      this.SelectedSeatType = type.areaCategoryCode;
      this.selectedSeatType = type.ID;
      // this.OnlySeatType.map(x => {
      //   if (x.SeatType !== type) {
      //     x.count = 0;
      //     x.clickDisabled = false;
      //   }
      // });
      // this.$refs.seattypesmodal.hide();
      // this.getSeatLayoutNew();
    },
    getTempSeatType: function() {
      let payload = {
        SchID: this.scheduleID
        // RequiredSeats: this.totalNumberOfSeats
      };
      makeRequest("/GetSeatType", "POST", null, payload).then(async result => {
        const { error, res } = result;
        if (
          !error &&
          res.data.Status &&
          res.data["SeatTypes"] &&
          res.data.SeatTypes.length > 0
        ) {
          let __SeatTypes = res.data.SeatTypes.filter(
            ({ SeatLabel }) => this.SeatTypeMT !== SeatLabel
          );
          let array = this.OnlySeatType.filter(({ count }) => count > 0);
          if (__SeatTypes.length > 0) {
            this.OnlySeatType = [];
            let promises = res.data.SeatTypes.map(x => {
              this.OnlySeatType.push({
                ...x,
                count: array.length > 0 ? array[0].count : 0,
                clickDisabled: array.length > 0 ? array[0].clickDisabled : false
              });
              return x;
            });
            await Promise.all(promises);

            this.getSeatLayoutNew();
          } else {
            this.getSeatLayoutNew();
          }
        }
      });
    },
    getSeatType: function() {
      console.log("this.OnlySeatType", this.OnlySeatType);
      let payload = {
        SchID: this.scheduleID
        // RequiredSeats: this.totalNumberOfSeats
      };

      makeRequest("/GetSeatType", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          //res.data.Status = false;
          if (!error && res.data.Status) {
            this.IsSeatTypePopup = res.data.IsPopup;

            this.OnlySeatType = res.data.SeatTypes;
            this.OnlySeatType.map(x => {
              x["count"] = 0;
              x["clickDisabled"] = false;
              return;
            });
            // this.SeatType = this.OnlySeatType[0].SeatType;
            // if (this.OnlySeatType.length == 1) {
            //   this.SeatType = this.OnlySeatType[0].SeatType;
            // }
            this.Currency = res.data.Currency;

            this.cinemaDetails = res.data.Cinema;
            this.showDate.actualDate = this.cinemaDetails.SchDate;
            this.showDate.actualtime = this.cinemaDetails.Time;
            this.SBScreenName = this.cinemaDetails.SBScreenName;
            this.SchTime = this.cinemaDetails.SchTime;

            let parts = this.showDate.actualDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
              day = parseInt(parts[2], 10);
            let date1 = new Date(year, month, day);
            this.showDate.day = this.days[date1.getDay()].substring(0, 3);
            this.showDate.date = date1.getDate();
            this.showDate.year = year;
            this.showDate.month = this.months[date1.getMonth()].substring(0, 3);

            this.getCinemaMovieTimes({
              MovieID: this.$route.params.movieID,
              show_date: this.showDate.actualtime,
              cinema_name: this.cinemaDetails.CinemaID
            });
            // if (this.IsSeatTypePopup == true) {
            //   this.$refs.showSeatNoModal.show();
            // } else {
            // if (this.IsSeatTypePopup == false) {
            this.showSeatNoModal();
            //  }
            // this.getSeatLayoutNew();
            // }
          } else {
            // this.$refs.noseattype.show();
            console.log("else :>> ", "else", res.data.Message);
            // this.SeatType = res.data.Message;
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    onSelectSeatType: function(type) {
      this.SeatType = type;
    },
    // CardonKeyUp: function(item, e) {
    //   console.log('item :', item,this.creditCardDetails.number[item].length);
    //   if (this.creditCardDetails.number[item].length > 4) {
    //     this.creditCardDetails.number[item] = this.creditCardDetails.number[item][this.creditCardDetails.number[item].length];
    //   }
    //   if (e.keyCode < 58 && e.keyCode > 47) {
    //     let value = "card" + (item + 2);
    //     this.$refs[value].focus();
    //   }
    // },
    fetchMovieDetails: function() {
      let token = null;
      let payload = {
        MovieID: this.movieID
      };
      // if (this.$persistStore.get("accessToken")) {
      //   token = this.$persistStore.get("accessToken");
      //   payload["access_token"] = token;
      // }
      makeRequest("/GetShowDetails", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              this.movieDetails = res.data.Show[0];

              let rating = this.movieDetails.rated || "";

              if (false && !["g"].includes(String(rating).toLowerCase())) {
                this.showRatedModal();
              } else {
                // this.showSeatNoModal();
              }

              // this.showDetails = res.data.
              // this.movieDetails["url"] =
              //   "/movie-showtimes-page?movieId=" + this.movieDetails.ID;
              // this.movieDetails.IMDBRating = this.movieDetails.IMDBRating.split(
              //   "/"
              // )[0];
              // this.movieDetails.IMDBRating = Math.round(
              //   parseFloat(this.movieDetails.IMDBRating)
              // );
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    confirmNumber: function() {
      $("html, body").animate(
        {
          scrollTop: 0
        },
        "slow"
      );
      if (this.totalNumberOfSeats < 1) {
        //   vm.$snack.metodo('Please Pick Number of Seats') // Displays a snackbar without action button
        return;
      }
      if (this.getSeatLayout == true) {
        this.sectionName.noOfSeats = false;
        this.sectionName.seatLayout = true;
        this.$root.$emit("bv::toggle::collapse", "checkout");
        this.getSeatLayoutNew();
      } else {
        this.sectionName.noOfSeats = false;
        //Handle No seat layout
        this.noSeatLayout();

        // this.sectionName.seatLayout = true;
        // this.getSeatLayoutNew();
      }

      // this.startTimer();
    },
    noSeatLayout: function() {
      let payload = {
        SchID: this.scheduleID,
        RequiredSeats: this.totalNumberOfSeats
      };

      makeRequest("/SNGetSeatLayout", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          //   const { data } = res.data;
          if (!res.data.Status) {
            this.SeatErrormessage = res.data.Message;
          }
          if (!error) {
            this.cinemaId = res.data.Cinema;
            console.log("Cinema Array", cinemaId);
            this.seatTypes = res.data.SeatTypes;

            console.log("seat type", this.seatTypes);
            this.selectedSeats = res.data.BookSeatsID;
            this.sectionName.noOfSeats = false;
            this.sectionName.checkout = true;
            this.sectionName.detailFooter = true;
            this.startTimer();
            this.bookingRequestConfirmSeats();
          } else {
            console.log("error from resp", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getSeatLayoutNew: function() {
      this.seatLayout = [];
      this.seatTypes = [];
      this.bookingTermsAndConditions = null;
      this.onErrorMeesage = null;
      this.myticketDisplaySeatType = "";
      this.OnlySeatType.map((x, index) => {
        if (x.count > 0) {
          this.myticketDisplaySeatType +=
            this.OnlySeatType.length - 1 == index
              ? x.SeatType + ":" + this.Currency + " " + x.Price
              : x.SeatType + ":" + this.Currency + " " + x.Price + " | ";
        }
      });
      // this.showLoading();
      let seatLayoutLoading = this.$loading.show({
        color: PROJECT == "ticketak" ? "#e0007c" : "#AD2318",
        // color: '#AD2318',

        loader: "spinner",
        width: 105,
        height: 105,
        class: "css-loader",
        backgroundColor: "rgba(0, 0, 0, 0.5);",
        opacity: 0.5,
        zIndex: 1000
      });
      let payload = {
        SchID: this.scheduleID,
        RequiredSeats: this.totalNumberOfSeats,
        SelectedSeatType: this.SelectedSeatType
      };
      // if (this.project == "myticketi") {
      //   payload.selectedSeats = this.OnlySeatType;
      // }

      makeRequest("/SNGetSeatLayout", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          this.seatLayout = [];
          this.seatTypes = [];

          if (!res.data.Status) {
            // this.SeatErrormessage = res.data.Message;
            res.data.Message == "The Requested ShowTime is Expired."
              ? (this.SeatErrormessage =
                  "The show you requested is unavailable")
              : (this.SeatErrormessage = res.data.Message);
          }
          //   const { data } = res.data;
          if (!error) {
            if (res.data.SeatCatWidth) {
              this.SeatCatWidth = res.data.SeatCatWidth;
            }
            if (this.SeatCatWidth.length == 0) {
              console.log(
                "this.SeatCatWidth.length :>> ",
                this.SeatCatWidth.length,
                res.data.SeatLayouts[0].length
              );
              for (let i = 0; i < res.data.SeatTypes.length; i++) {
                this.SeatCatWidth.push(
                  (res.data.SeatLayouts[0].length + 1) * 45
                );
              }
            }
            this.cinemaDetails = res.data.Cinema;
            this.Default = res.data.Default;
            let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            d.setUTCSeconds(this.cinemaDetails.Time);
            this.showDetails.month = d;
            this.showDate.actualDate = res.data.SchDate;
            this.SBScreenName = res.data.SBScreenName;
            // this.SchTime = res.data.SchTime;
            let parts = this.showDate.actualDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
              day = parseInt(parts[2], 10);
            let date1 = new Date(year, month, day);
            this.showDate.day = this.days[date1.getDay()].substring(0, 3);
            this.showDate.date = date1.getDate();
            this.showDate.year = year;
            this.showDate.month = this.months[date1.getMonth()].substring(0, 3);
            if (res.data.FNB) {
              this.foodAndBeverages.status = true;
              this.getFoodAndBeverages();
            }
            if (this.getSeatLayout == "1") {
              if (this.project == "ticketak") {
                this.seatLayout = res.data.SeatLayouts;
              } else {
                let startSeatLayout = res.data.SeatLayouts;
                let counter = 0;
                let array = [];
                this.seatLayout = [];
                this.seatTypes = [];
                startSeatLayout.map((row, rowIndex) => {
                  console.log(row, "row");
                  row.map((singleSeat, singleSeatIndex) => {
                    let arrayIndex = array.indexOf(singleSeat.SeatType);

                    if (arrayIndex > -1 && arrayIndex !== array.length - 1) {
                      console.log("singleSeat.SeatType :", singleSeat.SeatType);
                      singleSeat.SeatType = singleSeat.SeatType + "_1";
                      if (array.indexOf(singleSeat.SeatType) === -1) {
                        array.push(singleSeat.SeatType);
                      }
                    } else if (arrayIndex === -1) {
                      array.push(singleSeat.SeatType);
                    }
                  });
                });

                // thisstartSeatLayout = [...startSeatLayout].reverse();
                this.seatLayout = startSeatLayout.reverse();
              }

              let seatRowType = "";
              console.log(this.seatLayout, "jituggg");
              this.seatLayout.map(seatRow => {
                if (seatRowType != seatRow[0].SeatType) {
                  seatRowType = seatRow[0].SeatType;

                  this.seatTypes.push({
                    ID: seatRow[0]["ID"] || 291,
                    Price: seatRow[0].SeatPrice,
                    SeatID: seatRow[0].SeatClassID,
                    SeatType: seatRowType,
                    isuniqueSeat: seatRow[0].isuniqueSeat,
                    screen_id: seatRow[0].screen_id
                  });
                  // }
                }
              });
            } else {
              this.seatLayout = res.data.SeatLayouts;
              this.seatTypes = res.data.SeatTypes;
            }

            console.log(this.seatLayout, "hhhh", this.seatTypes);
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        })
        .finally(() => {
          this.hideLoading();
          seatLayoutLoading.hide();
        });
    },
    onSelectPromoCode(event) {
      let promocode = event.target.value.split("-");
      this.promoCode.selected.Title = promocode[0];
      this.promoCode.selected.PromotionID = promocode[1];
    },
    singleSeatSelectHandler: function(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      seat.seatIndex = seatIndex;
      seat.rowIndex = rowIndex;

      console.log(seat, "seat");
      if (type) {
        if (this.SeatType.length > 0 && this.SeatType !== type) {
          this.SeatType = "";
          this.selectedSeats.map(x => {
            this.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
            this.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          });
          this.selectedSeats = [];
          // this.singleSeatSelectHandler(
          //   this.seatLayout[rowIndex][parseInt(seatIndex)],
          //   rowIndex,
          //   seatIndex,
          //   originalIndex,
          //   backward,
          //   e,
          //   type
          // );
        }
        this.SeatType = type;
      }
      let firstTime = 0;

      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (this.totalNumberOfSeats != this.selectedSeats.length) {
        this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
      }

      if (this.seatLayout[rowIndex][seatIndex].SelectStatusFlag == false) {
        if (this.totalNumberOfSeats != this.selectedSeats.length) {
          this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
        }
      }
      //deselect all
      if (
        this.totalNumberOfSeats == this.selectedSeats.length &&
        firstTime == 1
      ) {
        this.selectedSeats.map(x => {
          this.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
          this.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
        });
        this.selectedSeats = [];
      }

      let removeSeats = this.selectedSeats.filter(r => {
        return r.seatIndex == seatIndex && r.rowIndex == rowIndex;
      });

      if (removeSeats.length > 0) {
        let addedSeatIndex = this.selectedSeats.findIndex(
          x => x.seatIndex === seatIndex && x.rowIndex == rowIndex
        );
        this.selectedSeats.splice(addedSeatIndex, 1);
        this.seatLayout[rowIndex][seatIndex].SelectStatus = false;
        this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = false;
      } else {
        if (this.seatLayout[rowIndex][seatIndex].SelectStatus == false) {
          //check if seat is selected, if yes, do nothing else
          //check how many selected
          if (
            parseInt(this.totalNumberOfSeats) - this.selectedSeats.length >
            0
          ) {
            this.seatLayout[rowIndex][seatIndex].SelectStatus = true;
            this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
            this.selectedSeats.push(seat);
          }
          let autoSeatIndex = seatIndex;

          let seatsTobeadded =
            parseInt(this.totalNumberOfSeats - 1) - this.selectedSeats.length;

          for (let z = 0; z <= seatsTobeadded; z++) {
            console.log(seatsTobeadded, "seatsTobeadded");
            if (
              parseInt(this.totalNumberOfSeats) != this.selectedSeats.length
            ) {
              autoSeatIndex = autoSeatIndex - 1;
              let newSeat = this.seatLayout[rowIndex][autoSeatIndex];
              if (newSeat) {
                //console.log(newSeat, "newSeat");
                if (
                  !newSeat.SeatName ||
                  newSeat.SeatName == "" ||
                  newSeat.Status != "1" ||
                  newSeat.SelectStatusFlag == true ||
                  newSeat.SelectStatus == true
                ) {
                  break;
                }
                newSeat.seatIndex = autoSeatIndex;
                newSeat.rowIndex = rowIndex;
                this.seatLayout[rowIndex][autoSeatIndex].SelectStatus = true;
                this.seatLayout[rowIndex][
                  autoSeatIndex
                ].SelectStatusFlag = true;
                this.selectedSeats.push(newSeat);
              }
            }
          }
        }
      }

      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.selectedSeats.map((x, index) => {
        this.singleTicketPrice = x.SeatPrice;
        this.totalAmount =
          parseFloat(this.totalAmount) + parseFloat(x.SeatPrice);
      });
    },
    onSelectCategory: function(value) {
      this.foodAndBeverages.selectedCategory = value;
    },
    onSeatConfirmaton: function() {
      console.log("onSeatConfirmaton");
      $("html, body").animate(
        {
          scrollTop: 0
        },
        "slow"
      );
      this.sectionName.checkout = true;
      this.sectionName.detailFooter = false;
      this.sectionName.seatLayout = false;
      this.totalAmount =
        parseFloat(this.totalAmount) + parseFloat(this.internetHandling);
      const token2 = TokenService.getToken();
      if (token2) {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: false
        };
        this.getUserDetails();
      } else {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: true
        };
      }
      //          this.dropDownFunction();
      this.sectionName.foodAndBeverages = false;
      this.startTimer();
      this.bookingRequestConfirmSeats();
    },
    bookingRequestConfirmSeats: function() {
      this.showLoading();
      let payload = {
        SchID: this.scheduleID,
        SelectedSeats: this.selectedSeats,
        movieID: this.movieID,
        cinemaID: this.cinemaDetails.CinemaID
      };
      if (this.project == "myticketi") {
        payload.TicketType = this.OnlySeatType;
      } else {
        console.log("BR OnlySeatType :", this.OnlySeatType, this.SeatType);
        this.OnlySeatType = this.OnlySeatType.map((x, seatIndex) => {
          if (this.SeatType == x.SeatLabel) {
            console.log(this.SeatType);
            x.count = this.selectedSeats.length;
          }
          return x;
        });
        payload.TicketType = this.OnlySeatType;
      }

      makeRequest("/BookingReserve", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            console.log("Booking Reserve: ", res.data);
            if (res.data.Status) {
              if (this.project == "tickekat") {
                //this.createNgeniusCardSection();
              }

              this.reserveID = res.data.ReserveID;
              this.isVoucherApplicable = res.data.isVoucherApplicable;
              this.isStudent = res.data.isstudentdiscount;
              this.discountAmount = res.data.ptdiscount;
              this.sectionName.foodAndBeverages = res.data.isfnb;
              //this.foodAndBeverages.selected = res.data.CinemaFNB.FNBCheck;
              console.log("res.data.totalseatcount :", res.data.totalseatcount);
              for (var i = 0; i < this.selectedSeats.length; i++) {
                console.log("for i :", i);
                //this.onSelectFoodItem(res.data.CinemaFNB.FNBCheck[0], "add", 0);
              }

              //this.bookFoodAndBeverages();
              this.glassval = parseInt(res.data.glassval);
              //this.bookingDetails.ptdvalue = 200;
              window.localStorage.setItem("ReserveID", this.reserveID);
              // this.getPaymentOptions();
              this.getReservesDetails();
              this.paymentBlock = true;
            } else {
              // this.sectionName.checkout = false;
              // this.sectionName.detailFooter = true;
              // this.sectionName.seatLayout = true;
              // this.$toasted.show(
              //   res.data.Message ||
              //     "Sorry! Something went wrong. kindly contact your administrator"
              // );
              this.onErrorMeesage =
                res.data.Message ||
                "Sorry! Something went wrong. kindly contact your administrator";
            }
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    changeNumberFormat(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    skipFnB() {
      this.foodAndBeverages.selected = [];
      this.fnbQty = 0;
      this.checkFnB = false;
      this.fnbCollapsed = false;
      console.log("F&B", this.foodAndBeverages.listing);
      Object.keys(this.foodAndBeverages.listing).map(category => {
        this.foodAndBeverages.listing[category].map(item => {
          item.Qty = 0;
        });
      });
      this.fnbtotal = 0;
      this.removeFnB();
    },
    onSelectFoodItem(foodItem, type, index) {
      console.log("foodItem :", foodItem);
      this.checkFnB = false;
      var currentQty = parseInt(
        this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty
      );
      if (type == "add") {
        currentQty += 1;
        if (currentQty <= 10) {
          this.foodAndBeverages.listing[foodItem.Category.Title][
            index
          ].Qty = currentQty;
          this.fnbtotal = parseInt(this.fnbtotal) + parseInt(foodItem.Amount);
        }
      }
      if (
        type == "subtract" &&
        this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty != 0
      ) {
        this.foodAndBeverages.listing[foodItem.Category.Title][
          index
        ].Qty -= parseInt(1);
        this.fnbtotal = parseInt(this.fnbtotal) - parseInt(foodItem.Amount);
      }

      this.foodAndBeverages.selected = [];
      this.fnbQty = 0;
      Object.keys(this.foodAndBeverages.listing).map(category => {
        this.foodAndBeverages.listing[category].map(item => {
          if (item.Qty != 0) {
            this.foodAndBeverages.selected.push(item);
          }
        });
      });
      this.foodAndBeverages.selected.map(fb => {
        this.fnbQty = parseInt(this.fnbQty) + parseInt(fb.Qty);
      });
      console.log("Selected F&B", this.foodAndBeverages.selected);
      this.checkDiscount = false;
    },
    getFoodAndBeverages: function() {
      return false;
      let payload = {
        SchID: this.scheduleID,
        CinemaID: this.cinemaDetails.CinemaID
      };
      let URL = "/GetFnBItems";
      if (this.cinemaDetails.CinemaID == 1) {
        //URL = "/GetFnBItemsCentury";
      } else {
        URL = "/GetFnBItems";
      }
      makeRequest(URL, "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.Status) {
            this.foodAndBeverages.listing = res.data.List;
            this.foodAndBeverages.allListing = res.data.List;
            console.log("FnB", this.foodAndBeverages.allListing);
            this.foodAndBeverages.listing = groupBy(
              this.foodAndBeverages.listing,
              "Category.Title"
            );
            //this.foodAndBeverages.Listing = res.data.ReserveID;
            this.sectionName.foodAndBeverages = true;
            console.log(this.sectionName.foodAndBeverages);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    removeFnB: function() {
      this.studentIDFilter = [];
      this.studentIDFilter = this.studentIDs.filter(x => {
        if (x != "") {
          console.log("index of student id", this.studentIDFilter.indexOf(x));
          if (this.studentIDFilter.indexOf(x) === -1) {
            return x;
          }
        }
      });
      this.Discount.isstudentcheck = this.studentCheck ? 1 : 0;
      this.Discount.totaldiscountticket = this.studentIDFilter.length;
      this.Discount.totalticketbook = this.totalNumberOfSeats;
      this.Discount.studentvaluearray = this.studentIDFilter;
      let payload = {
        ReserveID: this.reserveID,
        Flag: "Remove",
        StudentFlag: this.studentCheck,
        Discount: this.Discount,
        CinemaID: this.cinemaDetails.CinemaID
      };
      makeRequest("/BookingFNBItem", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.fnbCollapsed = false;
            this.checkFnB = true;
            this.getReservesDetails();
            //this.promotionDiscount();
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    bookFoodAndBeverages: function() {
      this.studentIDFilter = [];
      this.studentIDFilter = this.studentIDs.filter(x => {
        if (x != "") {
          console.log("index of student id", this.studentIDFilter.indexOf(x));
          if (this.studentIDFilter.indexOf(x) === -1) {
            return x;
          }
        }
      });
      this.Discount.isstudentcheck = this.studentCheck ? 1 : 0;
      this.Discount.totaldiscountticket = this.studentIDFilter.length;
      this.Discount.totalticketbook = this.totalNumberOfSeats;
      this.Discount.studentvaluearray = this.studentIDFilter;
      let payload = {
        ReserveID: this.reserveID,
        FNB: this.foodAndBeverages.selected,
        Flag: "Add",
        StudentFlag: this.studentCheck,
        Discount: this.Discount,
        CinemaID: this.cinemaDetails.CinemaID
      };
      makeRequest("/BookingFNBItem", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.fnbCollapsed = false;
            this.checkFnB = true;
            this.checkDiscount = true;
            this.getReservesDetails();
            //this.promotionDiscount();
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    submitUserDetails: function() {
      let payload = {
        ReserveID: this.reserveID,
        Email: userDetails.email,
        Mobile: userDetails.phoneNumber,
        CountryCode: userDetails.countryCode
      };
      makeRequest("/BookingFNBItem", "POST", null, payload)
        .then(nresult => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getReservesDetails() {
      this.bookingTermsAndConditions = null;

      let payload = {
        ReserveID: this.reserveID,
        ctoken: 1110266398,
        isscb: this.isscb,
        utm: {
          utm_campaign: TokenService.getUTM("utm_campaign"),
          utm_medium: TokenService.getUTM("utm_medium"),
          utm_source: TokenService.getUTM("utm_source")
        }
      };
      makeRequest("/ReserveDetails", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.bookingDetails = res.data;
            this.bookingTermsAndConditions =
              res.data["TermsAndConditions"] || null;

            //this.bookingDetails.glassInfoHover = true;
            //this.bookingDetails.glassInfoMessage = "*These are the fees for the 3D glasses which are compulsory and collected on behalf of the cinema management. In case you have any concerns, please reach out to the manager / customer service desk at the cinema.";
            if (this.bookingDetails.fnb_total > 0) {
              this.bookingDetails.total_amt =
                parseInt(this.bookingDetails.total_amt) +
                parseInt(this.bookingDetails.fnb_total);
              this.glassval = parseInt(this.bookingDetails.glassval);
            }
            if (this.bookingDetails.Ispromotionsctive == 1) {
              this.isPromo = true;
            }
            this.bookingDetailsCopy = res.data;
            console.log("glass val", this.glassval);
            //this.promotionDiscount();

            if (this.bookingDetails.Offer == 1 && this.offerPopupCheck) {
              this.$refs.offermodal.show();
              this.offerPopupCheck = false;
            }

            this.hideLoading();
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
          this.hideLoading();
        });
    },
    // getPaymentOptions: function () {
    //   this.savedCreditCards = [];
    //   let payload = {
    //     ReserveID: this.reserveID,
    //   };
    //   makeRequest("/GetPaymentOptions", "POST", null, payload)
    //     .then((result) => {
    //       const { error, res } = result;
    //       if (!error && res.status) {
    //         //   console.log(" pay Options res ", res);
    //         // console.log(" pay Options Data ", res.data);
    //         res.data.Paymentoptions.forEach((singlePaymentOption) => {
    //           if (singlePaymentOption.PaymentID == 3) {
    //             singlePaymentOption.Cards = singlePaymentOption.Cards.forEach(
    //               (x) => {
    //                 x["CVV"] = "";
    //                 this.savedCreditCards.push(x);
    //               }
    //             );
    //             //   this.savedCreditCards = singlePaymentOption.Cards;
    //             // console.log('test1', this.savedCreditCards,singlePaymentOption.Cards )
    //           }
    //         });
    //         this.newPaymentOptions = res.data.Paymentoptions;
    //         // this.savedCreditCards = res.data.Paymentoptions[1];
    //         // this.paymentOptions = data.paymentOptions.Paymentoptions;
    //       } else {
    //         console.log("error from res", res.message);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error on vue front", error);
    //     });
    // },
    onRemoveCard: function(card) {
      let token = TokenService.getToken();
      let payload = {
        CardID: card.cardID
      };
      makeRequest("/RemoveCard", "POST", token, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.$toasted.show(res.data.Message);
            //this.getPaymentOptions();
            this.getSavedCards();
            setTimeout(() => {
              this.$toasted.clear();
            }, 3000);
          } else {
            this.cardError = res.data.Message;
            this.$toasted.show(res.data.Message);
            setTimeout(() => {
              this.$toasted.clear();
            }, 3000);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    verifyPromotion: function(type) {
      //console.log("Promo Data - ", promo);
      let token = TokenService.getToken();
      this.VoucherMsg = "";

      let payload = {
        voucher_code: this.voucherCode,
        movieID: this.movieID,
        cinemaID: this.cinemaDetails.CinemaID,
        reserveID: this.reserveID,
        activityType: type
      };
      makeRequest("/verifyVoucher", "POST", token, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.voucherApplied = true;
            this.VoucherMsg = res.data.Message;
            this.getReservesDetails();
            if (type == "0") {
              this.voucherCode = "";
              this.voucherApplied = false;
            }
            //
          } else {
            this.hideLoading();
            this.VoucherMsg = res.data.Message;
          }
        })
        .catch(error => {
          this.hideLoading();
          //  this.promoCode.errorMessage = "Something went wrong";
        });
    },
    editDetails() {
      this.modal.signIn = true;
      this.modal.userTicketsDetails = false;
      this.modal.payment = false;
    },
    processPayment: function() {
      const token2 = TokenService.getToken();

      let payload = {
        ReserveID: this.reserveID,
        PaymentID: 1
        // PromotionID: 0
      };
      if (this.promoCode.selected) {
        payload.PromotionID = this.promoCode.selected.PromotionID;
      }
      makeRequest("/ProcessPayment", "POST", token2, payload)
        .then(result => {
          const { error, res } = result;
          if (res.data.Status) {
            this.showOTP = true;
          } else {
            this.ProcessPaymentMessage = res.data.Message;
          }
        })
        .catch(error => {
          this.ProcessPaymentMessage = "Something went wrong";
        });
    },
    onRemoveReferralPromotion: function() {
      console.log("Promo Data - ", this.promoCode);
      this.SelectedReferralCode.map(x => {
        let indexNew = this.promoCode.promoList.findIndex(y => {
          return x.ID == y.ID;
        });
        console.log("indexNew :", indexNew);
        if (indexNew >= 0) {
          this.promoCode.promoList[indexNew]["Apply"] = false;
        }
      });
      let token = TokenService.getToken();
      this.promoCode.message = "";
      let payload = {
        ReserveID: this.reserveID,
        flag: "Remove",
        PromotionID: 1,
        Tab: "Referral"
      };
      console.log("Referral payload :", payload);
      makeRequest("/VerifyPromotion", "POST", token, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.promoApplied = false;
            //this.onRemovedPromocode();
            this.getReservesDetails();
          } else {
            this.promoCode.promoList[promokey]["errorMessage"] =
              res.data.Message;
            this.promoCode.errorMessage = res.data.Message;
          }
        })
        .catch(error => {
          this.promoCode.errorMessage = "Something went wrong";
        });
    },
    onRemovedPromocode: function() {
      this.isPromoFromList = false;
      this.promoApplied = false;
      this.promoCode.message = "";
      this.promoCode.selected.Title = "";
      this.promoCode.selected.Name = "";
      this.promoCode.selected.PromotionID = "";
      this.promoCode.promoList = [];
      this.promoCode.errorInputMessage = "";
      (this.promoCode.errorMessage = ""),
        (this.promoCode.successMessage = ""),
        (this.promoCodeapplied = false);
      this.bookingDetails = this.bookingDetailsCopy;

      /* Remove Coupon Applied */
      let token = TokenService.getToken();
      this.promoCode.message = "";
      let payload = {
        ReserveID: this.reserveID,
        flag: "Remove",
        PromotionID: 1,
        Tab: "Promotions"
      };
      makeRequest("/VerifyPromotion", "POST", token, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.promoApplied = false;
            //this.onRemovedPromocode();
            this.getReservesDetails();
          } else {
            this.promoCode.promoList[promokey]["errorMessage"] =
              res.data.Message;
            this.promoCode.errorMessage = res.data.Message;
          }
        })
        .catch(error => {
          this.promoCode.errorMessage = "Something went wrong";
        });
      /* Remove Coupon Applied */

      this.getPromotionList();
    },
    showApplyCouponModal: function() {
      if (!this.studentCheck) {
        this.$refs.applycouponModal.show();
      } else {
        this.promotionNotAllowed = "You have already applied for a coupon.";
        this.$refs.couponNotAllowed.show();
      }
    },
    hideReferralModal: function() {
      this.$refs.applycouponModal.hide();
    },
    onselectcard: function(card) {
      this.selectedCard = card;
    },
    couponNotAllowedHide: function() {
      this.promotionNotAllowed = "";
      this.$refs.couponNotAllowed.hide();
    },
    onClickExpressPay: function() {
      console.log("this.selectedCard.CVV :", this.selectedCard.cardID);
      /*let self = this;
      self.showLoading();
      var sessionId;
      window.NI.generateSessionId()
        .then(function(response) {
          sessionId = response.session_id;
          console.log(sessionId);
          if (typeof response.session_id !== "undefined") {
            let payload = {
              ReserveID: self.reserveID,
              sid: sessionId,
              saveCard: self.savecardradio ? 1 : 0,
              cardID: 0 //self.selectedCard.cardID
            };
            console.log("payload :", payload);
            makeRequest("/NProcessPayment", "POST", null, payload)
              .then(response => {
                console.log("result :", response);
                const { res } = response;
                // console.log('Data :', Data);
                if (res.data.Status) {
                  document.getElementById("3ds_iframe").innerHTML =
                    res.data.Data;
                  self.paymentBlock = false;
                  self.check3ds(res.data.Data);
                  self.hideLoading();
                } else {
                  self.$toasted.show(res.data.Message, {
                    position: "top-center",
                    duration: 5000
                  });
                }
              })
              .catch(error => {
                self.$toasted.show(error, {
                  position: "top-center",
                  duration: 5000
                });
              });
            // $.ajax({
            //     url: "http://192.168.1.155/pay.php",
            //     type: "post",
            //     dataType: 'json',
            //     data: {
            //         sid: sessionId
            //     },
            //     success: function (result) {
            //       console.log('result :', result);
            //         document.getElementById("3ds_iframe").innerHTML = result;
            //         self.check3ds(result);
            //     },
            //     error: function (error) {
            //         console.log(error);
            //         self.$toasted.show(error, {
            //             position: "top-center",
            //             duration : 5000
            //     });
            //     }
            // });
          } else {
            self.$toasted.show(
              "Session cannot be generated, Please try again later",
              {
                position: "top-center",
                duration: 5000
              }
            );
          }
        })
        .catch(error => {
          console.log("error :", error);
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        });*/
      this.PayViaNgenius(this.selectedCard.cardID);
      /*this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        PaymentID: "3",
        ReserveID: this.reserveID,
        CVV: this.selectedCard.CVV,
        cardID: this.selectedCard.cardID,
        PromotionID: 0
      };
      makeRequest("/ProcessPayment", "POST", token, payload)
        .then(result => {
          this.hideLoading();
          const { error, res } = result;
          // if (!error && res.data.Status) {
          if (res.data._3DSecure == true) {
            let otpUrl = res.data._links.acsUrl;
            // this.bankPage.src = otpUrl;
            // console.log("otpUrl :", otpUrl);
            window.open(otpUrl, "_self");
          } else if (res.data._3DSecure == false) {
            window.location.pathname =
              "/processPayment/" + this.reserveID + "/" + res.data.token;
          }
          // if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
          //   this.creditCardDetails.error = res.data.ErrDesc.ErrorMessage;
          // } else {
          //   this.bankPage.src = res.data.ErrDesc._links.acsUrl;
          // }
          else {
            this.cardError = res.data.Message;
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          this.cardError = "Please Provide Valid card details";

          console.log("Error on vue front", error);
        });*/
    },
    confirmBooking: function() {
      let payload = {
        ReserveID: this.reserveID,
        PaymentID: 1,
        LanguageID: 2,
        CountryID: 230,
        OTP: this.OTP
      };
      //if token send token else empty
      makeRequest("/ConfirmBooking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            this.finalBookingID = res.data.BookingID;
            this.getBookingDetails();
          } else {
            this.ProcessPaymentMessage = res.data.Message;
          }
        })
        .catch(error => {
          this.ProcessPaymentMessage = "Something went wrong";
          console.log("Error on vue front", error);
        });
    },
    getBookingDetails: function() {
      let payload = {
        BookingID: this.finalBookingID
      };

      makeRequest("/GetBookingDetails", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("booking fetch final Confirmation", res.data);
          if (!error) {
            this.finalBookingDetails = res.data;
            this.sectionName.checkout = false;
            this.$refs.OTPModal.show();
            this.sectionName.confirmation = true;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    selectPromoFromList: function(promo, e) {
      e.preventDefault();
      if (this.promoCode.selected.Title == "Reset Offer") {
        this.promoCode.selected = {
          Title: "Select Offer"
        };
        return;
      } else {
        this.promoCode.selected = promo;
      }
    },
    restartBooking: function(e) {
      e.preventDefault();
      let movieId = this.$route.query.movieID;
      let scheduleId = this.$route.query.scheduleID;
      let seatLayout = this.$route.query.seatLayout;
      window.location = `/checkout/${scheduleId}/${movieId}/${seatLayout}`;
    },
    payUsingWallet: function() {
      let token = this.$persistStore.get("accessToken");
      let payload = {
        access_token: token,
        usertranstion: {
          Amount:
            this.totalAmount +
            this.seatData.ConFee * this.selectedSeats.length -
            this.discount,
          Narration: "Booked ticket for The Godfather",
          OrderId: this.bookingID,
          PaymentType: 3,
          TransType: 0,
          UserId: "105"
        }
      };
      makeRequestDirect("/cinematic/DebitTransation", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("payment request", res.data);
          if (!error) {
            this.walletResponse = res.data;
            this.OTPScreen = true;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    makeSavedCardPayment: function(cardID, CVV, $event) {
      console.log("cardID", cardID);
      $event.preventDefault();
      let token = this.$persistStore.get("accessToken");
      console.log("cardID", cardID);
      let payload = {
        PaymentID: "3",
        access_token: token,
        bookingOrderId: this.bookingID,
        cardDetails: {
          CVV: CVV,
          CardID: cardID
        }
      };
      makeRequestDirect("/ProcessPayment", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("payment request", res.data);
          if (!error) {
            console.log("otp page");
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    validateBeforeSubmit(scope) {
      if (scope == "cardDetails") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            //this.makeCardPayment();
            this.PayViaNgenius(0);
            return;
          }
        });
      } else if (scope == "bookUser") {
        // console.log("Hello", this.checkoutButtonStatus)
        // if (this.checkoutButtonStatus) {

        // } else {
        //   this.showPaymentCollapse = false;
        // }
        this.studentIDFilter = [];
        this.studentIDFilter = this.studentIDs.filter(x => {
          if (x != "") {
            console.log("index of student id", this.studentIDFilter.indexOf(x));
            if (this.studentIDFilter.indexOf(x) === -1) {
              return x;
            }
          }
        });

        this.checkDiscount = true;

        console.log("Student", this.studentIDFilter);
        console.log("Total Ticket", this.totalNumberOfSeats);
        console.log("Student ID Count", this.studentIDFilter.length);
        console.log("Student Check", this.studentCheck ? 1 : 0);
        this.$validator.validateAll(scope).then(result => {
          this.Discount.isstudentcheck = this.studentCheck ? 1 : 0;
          this.Discount.totaldiscountticket = this.studentIDFilter.length;
          this.Discount.totalticketbook = this.totalNumberOfSeats;
          this.Discount.studentvaluearray = this.studentIDFilter;
          if (result) {
            let payload = {
              Email: this.userDetails.email,
              Mobile: this.userDetails.phoneNumber,
              ReserveID: this.reserveID,
              CountryCode: this.userDetails.countryCode || 91,
              Discount: this.Discount
            };
            makeRequest("/UpdateBookUser", "POST", null, payload)
              .then(response => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  // this.checkingOnPaymentCall();
                  this.modal.signIn = false;
                  this.modal.payUsingWallet = false;
                  this.modal.userTicketsDetails = true;
                  this.modal.payment = true;
                  this.verifyError = "";
                  console.log("payment_options :");
                  this.firstCollapsed = false;
                  this.secondCollapsed = true;
                  this.$root.$emit("bv::toggle::expand", "payment_options");
                  // this.$refs.OTPModal.show();
                  // this.processPayment();
                  if (this.project == "ticketak") {
                    this.getSavedCards();
                  }
                  this.onErrorMeesage = null;
                  this.getPaymentOptions();
                  this.getReservesDetails();
                } else {
                  this.onErrorMeesage = res.data.Message;
                  this.showPaymentCollapse = false;
                  this.verifyError = res.data.Message;
                  this.checkoutButtonStatus = false;
                  setTimeout(() => {
                    let elmnt = document.getElementById("errorMsgDisplay");
                    elmnt.scrollIntoView({
                      behavior: "smooth",
                      inline: "start"
                    });
                  }, 0);
                }
              })
              .catch(error => {
                this.verifyError = "Something went wrong";
              });
            return;
          }
        });
      }
    },
    getSavedCards: function() {
      //let token = this.$persistStore.get("accessToken");
      let token = "";
      let payload = {
        email: this.userDetails.email
      };
      console.log("payload :", payload);
      makeRequest("/GetSavedCards", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.data.Status) {
            if (res.data.Cards.length > 0) {
              this.savedCreditCards = res.data.Cards;
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    onclickpaynow: function(ind) {
      this.showLoading();
      console.log("ind", ind);
      window.location.href =
        this.payment_options[ind].redirect_url +
        "&reserve_id=" +
        this.reserveID;
    },
    onclickpaynow1: function() {
      window.localStorage.setItem(
        "IHC",
        this.bookingDetails.total_internet_handling_amt
      );
      window.localStorage.setItem("sku", this.scheduleID);
      let singleTicketPrice =
        parseFloat(this.bookingDetails.amount) /
        parseInt(this.totalNumberOfSeats);
      window.localStorage.setItem("STP", singleTicketPrice);

      // let route = this.$router.resolve({ path: this.bookingDetails.PayURL });
      window.open(this.bookingDetails.PayURL, "_self");

      // if (this.project == "ticketak") {
      //   // this.PayViaNgenius();
      //   this.payNowNetowrk();
      //   //this.checkingOnPaymentCall();
      // } else if (this.project == "myticketi") {
      //   this.$refs.redirectPayment.show();
      // }
    },

    async PayViaNgenius(cardID) {
      let self = this;
      self.showLoading();
      var sessionId;
      await window.NI.generateSessionId()
        .then(function(response) {
          sessionId = response.session_id;
          console.log(sessionId);
          if (typeof response.session_id !== "undefined") {
            let payload = {
              ReserveID: self.reserveID,
              sid: sessionId,
              saveCard: self.savecardradio ? 1 : 0,
              cardID: cardID
            };
            console.log("payload :", payload);
            makeRequest("/NProcessPayment", "POST", null, payload)
              .then(response => {
                console.log("result :", response);
                const { res } = response;
                // console.log('Data :', Data);
                if (res.data.Status) {
                  document.getElementById("3ds_iframe").innerHTML =
                    res.data.Data;
                  self.paymentBlock = false;
                  self.check3ds(res.data.Data);
                  self.hideLoading();
                } else {
                  self.$toasted.show(res.data.Message, {
                    position: "top-center",
                    duration: 5000
                  });
                }
              })
              .catch(error => {
                self.$toasted.show(error, {
                  position: "top-center",
                  duration: 5000
                });
              });
            // $.ajax({
            //     url: "http://192.168.1.155/pay.php",
            //     type: "post",
            //     dataType: 'json',
            //     data: {
            //         sid: sessionId
            //     },
            //     success: function (result) {
            //       console.log('result :', result);
            //         document.getElementById("3ds_iframe").innerHTML = result;
            //         self.check3ds(result);
            //     },
            //     error: function (error) {
            //         console.log(error);
            //         self.$toasted.show(error, {
            //             position: "top-center",
            //             duration : 5000
            //     });
            //     }
            // });
          } else {
            self.$toasted.show(
              "Session cannot be generated, Please try again later",
              {
                position: "top-center",
                duration: 5000
              }
            );
          }
        })
        .catch(error => {
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        })
        .finally(function() {
          self.hideLoading();
        });
    },
    check3ds(paymentResponse) {
      let self = this;
      if (typeof paymentResponse.orderReference !== "undefined") {
        window.NI.handlePaymentResponse(paymentResponse, {
          mountId: "3ds_iframe"
        }).then(function(response) {
          var status = response.status;

          console.log(status);
          console.log(paymentResponse.orderReference);
          if (
            status == "AUTHORISED" &&
            paymentResponse &&
            paymentResponse.orderReference &&
            paymentResponse.orderReference.length > 0
          ) {
            self.makeTransactions(paymentResponse);
            //self.authoriseReserve(self.reserveID, status, paymentResponse);
          } else {
            self.$toasted.show(status, {
              position: "top-center",
              duration: 5000
            });
          }
        });
      } else {
        self.$toasted.show("Unable to process payment", {
          position: "top-center",
          duration: 5000
        });
        //document.getElementById("error").style.display = "block";
        //document.getElementById("error").innerHTML = paymentResponse.error;
      }
    },
    authoriseReserve(ReserveID, Status, paymentResponse) {
      let self = this;
      let payload = {
        ReserveID: ReserveID,
        Status: Status
      };
      makeRequest("/AuthoriseCheck", "POST", null, payload)
        .then(response => {
          const { res } = response;
          if (
            Status == "AUTHORISED" &&
            paymentResponse &&
            paymentResponse.orderReference &&
            paymentResponse.orderReference.length > 0
          ) {
            self.makeTransactions(paymentResponse);
          } else {
            self.$toasted.show(status, {
              position: "top-center",
              duration: 5000
            });
          }
        })
        .catch(error => {
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        });
    },
    makeTransactions(paymentResponse) {
      let self = this;
      let payload = {
        ReserveID: self.reserveID,
        orderReference: paymentResponse.orderReference
      };
      makeRequest("/ProcessTicket", "POST", null, payload)
        .then(response => {
          const { res } = response;
          if (res.data.Status) {
            self.$router.push({
              path:
                "/paymentCheck?ref=" +
                paymentResponse.orderReference +
                "&rid=" +
                self.reserveID
            });
          } else if (res.data.Rebook) {
            self.makeTransactions(paymentResponse);
          } else {
            self.$toasted.show(res.data.Message, {
              position: "top-center",
              duration: 5000
            });
          }
        })
        .catch(error => {
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        });
    },
    makeCardPayment: function() {
      this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        PaymentID: "2",
        // access_token: token,
        ReserveID: this.reserveID,
        PromotionID: 0,
        // cardDetails: {
        cardNumber: this.creditCardDetails.number.toString().replace(/,/g, ""),
        expiryMonth: this.creditCardDetails.expiryMonth,
        expiryYear: this.creditCardDetails.expiryYear,
        CVV: this.creditCardDetails.cvv,
        cardNameHolder: this.creditCardDetails.name,
        saveCard: "1"
        // }
      };
      if (!this.creditCardDetails.saveCard) {
        payload.saveCard = "0";
      }
      makeRequest("/ProcessPayment", "POST", null, payload)
        .then(result => {
          this.hideLoading();
          const { error, res } = result;
          console.log("payment request", res.data);
          // if (!error && res.data.Status) {
          if (res.data._3DSecure == true) {
            let otpUrl = res.data._links.acsUrl;
            // this.bankPage.src = otpUrl;
            // console.log("otpUrl :", otpUrl);
            window.open(otpUrl, "_self");
          } else if (res.data._3DSecure == false) {
            window.location.pathname =
              "/processPayment/" + this.reserveID + "/" + res.data.token;
          }
          // if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
          //   this.creditCardDetails.error = res.data.ErrDesc.ErrorMessage;
          // } else {
          //   this.bankPage.src = res.data.ErrDesc._links.acsUrl;
          // }
          // }
          else {
            this.cardError = res.data.Message;
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          this.cardError = "Please Provide Valid card details";

          console.log("Error on vue front", error);
        });
    },
    bookingOrderConfirm: function() {
      let token = this.$persistStore.get("accessToken");
      let payload = {
        OTP: "1234",
        PaymentID: "1",
        access_token: token,
        bookingOrderId: this.bookingID
      };

      makeRequestDirect("/cinematic/BookingOrderConfirm", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("booking OTP Confirmation", res.data);
          if (!error) {
            this.sectionName = {
              seatLayout: false,
              checkout: false,
              confirmation: true,
              noOfSeats: false,
              typeSelector: false
            };
            this.finalBookingID = res.data.BookingOrderId;
            this.getBookingDetails();
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },

    // editContactDetailsToggle: function(e) {
    //   if (e) e.preventDefault();
    //   this.paymentModal.editContactDetails = !this.paymentModal
    //     .editContactDetails;
    //   this.paymentModal.viewContactDetails = !this.paymentModal
    //     .viewContactDetails;
    // },
    submitContactDetails: function(e) {
      e.preventDefault();
      //TODO Submit New Contact Details

      this.editContactDetailsToggle();
    },
    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        let self = this;
        if (this.timer.stop == true) {
          return;
        }
        if (
          parseInt(this.timer.seconds) == 0 &&
          parseInt(this.timer.minutes) == 0
        ) {
          // this.timer.seconds = 60;
          this.timer.stop = false;
          clearTimeout(self.timerStartFunction);
          this.$refs.sessionTimeOut.show();
          this.sessionExpired();
          return false;
        }
        if (
          this.timer.seconds == "00" &&
          this.timer.minutes == 2
          // sectionName.checkout == true
        ) {
          this.$refs.hurryupmodal.show();
          setTimeout(() => {
            this.$refs.hurryupmodal.hide();
          }, 10000);
        }

        if (parseInt(this.timer.seconds) == 0) {
          this.timer.seconds = 60;
        }
        this.timer.seconds = parseInt(this.timer.seconds) - 1;
        if (this.timer.seconds < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }
      }, 1000);
      var myVar = setInterval(() => {
        if (this.timer.stop == true) {
          return;
        }
        if (this.timer.minutes == 0 && this.sectionName.checkout == true) {
          //TODO Show timeout message and a redirect button
          this.$refs.sessionTimeOut.show();
          this.sessionExpired();
          clearTimeout(myVar);
          this.timer.TimeoutModal = true;
          this.timer.minutes = 0;
          this.timer.seconds = 0;
          this.timer.stop = true;
        }
        this.timer.minutes = parseInt(this.timer.minutes) - 1;
      }, 60000);
    },
    userSigninModalBack: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    getIPAddress: function() {
      makeRequest("/GetCountryList", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          const { data } = res.data;
          this.UserIPAddress = res.data.Default.IPAddress;
          this.Default = res.data.Default;
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    editNumberOfSeats: function(number) {
      this.totalNumberOfSeats = number;
    },
    showUserLogInModal: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    showGuestModal: function(e) {
      e.preventDefault();
      this.modal = {
        signIn: false,
        guestLogin: true,
        payment: false
      };
    },
    checkOutAsGuest: function() {
      //Save Details to user Details
      //check values of details
      if (this.userDetails && this.phoneNumber) {
        this.insertBookingOrderUserDetails();
        this.sectionName.checkout = true;
        this.modal.payment = true;
        modal.guestLogin = false;
      } else {
        this.guest.errorMessage = "Please enter a valid email and Phone Number";
      }

      //show payment details
    },
    getUserDetails: function(callback) {
      let payload = {};

      makeRequest("/GetProfile", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error && res.status) {
            console.log("get User Details Data on my account  >>", res.data);
            // userDetails
            this.userDetails.email = res.data.Email;
            this.userDetails.phoneNumber = res.data.Mobile;
            this.userDetails.userName = res.data.UserName;
            this.userDetails.countryCode = res.data.CountryCode;
            this.modal.payUsingWallet = false;
            this.onKeyUp(null, "email");
            this.isUserLoggedIn = true;
            this.onKeyUp(null, "mobile");
            //   this.userDetails.phoneNumber = data.userDetails.MobileNo.replace(
            //       /\D/g,
            //       ""
            //   );
            if (callback) {
              callback();
            }
            //   this.userDetails.profilePic =
            //       data.userDetails.ProfileURl.length > 0
            //           ? data.userDetails.ProfileURl
            //           : "/images/svg/icon-profile.svg";
            //   this.loginData.loginInput.email = data.userDetails.Email;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    onConfirmSubmit: function() {
      // this.getReserveSeatsDetails,
      //   this.getSeatIds
      let payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      makeRequest("/api/reserve-booking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.status) {
            console.log(" Reserve Seats Data ", data);
            if (data.reserveBooking.Status) {
              secureStore.set("GSRID", data.reserveBooking.ReserveID);
              this.$router.replace({
                path: "/seat-payment-mode",
                params: {}
              });
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    getPromotionList: function() {
      let token = TokenService.getToken();
      makeRequest("/GetPromotionList", "POST", token, null)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            if (res.data.UserPromotion) {
              this.promoCode.promoList = res.data.UserPromotion;
            }
            if (
              this.showDate.actualDate == "2020-02-14" &&
              this.sectionName.noOfSeats >= 2
            ) {
              this.isPromo = res.data.IsPromo;
            } else {
              this.isPromo = false;
            }
            console.log("this.isPromo :", this.isPromo);
            this.PromotionTabs = res.data.tabs;
            res.data.Promotions.map(promo => {
              this.promoCode.promoList.push(promo);
              // this.promoListCopy.push(promo);
            });
            this.promoListCopy = res.data.Promotions;
            // this.promoList.promoListCopy = this.promoCode.promoList;

            // this.promoCode.promoList.push({
            //   Title: "Reset Offer"
            // });
          }
        })
        .catch(error => {
          console.log("Error ", error);
        });
    },
    verifyPromoCode: function(e, type) {
      e.preventDefault();
      //   console.log("Here testing", this.promoCode.input);

      if (type == "bankOffer") {
        let payload = {
          OfferID: this.promoCode.selected.ID,
          CardNumber: this.creditCardDetails.number
        };
        makeRequestDirect("/api/Payment/VerifyCoupon/", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            const { data } = res.data;
            console.log("Checking Verify Coupon result >", res.data);
            if (!error && res.data.Status) {
              this.discount = res.data.DiscountValue;
              this.promoCode.button = true;
              this.promoCode.errorMessage = "";
              this.promoCode.successMessage = res.data.Message;
            } else {
              this.discount = 0;
              this.promoCode.errorMessage = res.data.Message;
              this.promoCode.successMessage = "";
            }
          })
          .catch(error => {
            console.log("Error ", error);
          });
      } else {
        let payload = {
          CouponCode: this.promoCode.input,
          Total: this.totalAmount
        };
        makeRequestDirect("/api/Payment/VerifyCoupon/", "POST", null, payload)
          .then(response => {
            const { error, res } = response;
            const { data } = res.data;
            console.log("Checking Verify Coupon result >", res.data);
            if (!error && res.data.Status) {
              this.discount = res.data.DiscountValue;
              this.promoCode.button = true;
              this.promoCode.errorMessage = "";
              this.promoCode.successMessage = res.data.Message;
            } else {
              this.discount = 0;
              this.promoCode.errorMessage = res.data.Message;
              this.promoCode.successMessage = "";
            }
          })
          .catch(error => {
            console.log("Error ", error);
          });
      }
    },

    getWallet: function() {
      // console.log("Here Wallet  >>", payment);
      let payload = {
        reserveId: this.reserveBookingId
      };

      makeRequestDirect("/cinematic/GetUserWallet", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          console.log("check-wallet Result ", res);
          if (!error && res.data.status && res.data.data.checkWallet.Status) {
            this.status.enableOtpFlag = true;
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    paymentConfirmation: function(e) {
      //   e.preventDefault();
      this.bankPage.src = "";
      this.savedBankPage.src = "";
      this.sectionName.confirmation = true;
      this.sectionName.checkout = false;
      //BookAPI
      this.getBookingDetails();
      //TODO Fetch final BookingID
    },
    userLogIn: function(e) {
      e.preventDefault();
      makeRequest("/api/signin", "POST", null, {
        Password: this.userDetails.password,
        UserName: this.userDetails.email
      })
        .then(response => {
          const { error, res } = response;

          const { data } = res.data;
          console.log(res, "<<< Sign Im Data >>>", data);
          if (!error && res.data.status && data.result.Status) {
            // Handle Sign In
            this.$persistStore.set("accessToken", data.result.access_token);
            this.signIn.flag = true;
            this.modal.signIn = false;
            this.sectionName.checkout = true;
            EventBus.$emit("LoginUser", {
              status: true,
              userName: "test1"
            });
            this.modal.payment = true;
            // this.getUserDetails(() => {
            //   this.insertBookingOrderUserDetails();
            // });
          } else if (!data.result.Status) {
            this.loginErrorMessage = data.result.Message;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    handlerSeatSelected: function(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      this.singleSeatSelectHandler(
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type
      );
    },
    reserveSeatsSelected: function() {
      let payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      makeRequest("/api/reserve-booking", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.status) {
            console.log(" Reserve Seats Data ", data);
            if (data.reserveBooking.Status) {
            }
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    },
    onclickok: function() {
      this.$refs.redirectPayment.hide();
      this.showLoading();
      let payload = {
        ReserveID: this.reserveID,
        email: this.userDetails.email,
        mobile: this.userDetails.phoneNumber,
        countrycode: this.userDetails.countryCode,
        CinemaType: "normal",
        PaymentID: 2,
        SucessUrl: this.ConfirmationURL,
        FailUrl: this.FailedURL,
        ApiCallURL: this.BASEURL,
        ismobile: 0
      };
      makeRequest("/MakePayment", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (res.data.Status) {
            let links = res.data.links;
            var x = document.getElementById("form_sample");
            var createform = document.createElement("form"); // Create New Element Form
            createform.setAttribute("action", links.requestUrl); // Setting Action Attribute on Form
            createform.setAttribute("method", "post"); // Setting Method Attribute on Form
            createform.setAttribute("ref", "submitForm"); // Setting Method Attribute on Form
            createform.setAttribute("name", "submitForm"); // Setting Method Attribute on Form
            x.appendChild(createform);
            let params = links.requestParameter;

            Object.keys(params).map(x => {
              var submitelement = document.createElement("input"); // Append Submit Button
              submitelement.setAttribute("type", "text");
              submitelement.setAttribute("name", x);
              submitelement.setAttribute("value", params[x]);
              createform.appendChild(submitelement);
            });

            var _submitelement = document.createElement("input"); // Append Submit Button
            _submitelement.setAttribute("type", "submit");
            _submitelement.setAttribute("value", "submit");
            createform.appendChild(_submitelement);

            setTimeout(() => {
              document.submitForm.submit();
              this.hideLoading();
              // this.$nextTick(() => {
              //   // this.sessionStore.set("EMRID", this.reserveID);
              //   this.$refs.submitForm.submit();
              // });
            }, 2000);
          }
        })
        .catch(error => {
          // this.$root.$emit("bv::show::modal", "checkoutModal");
          // this.userDetails.errorMessage = "Something went wrong!";
          // console.log("Error on vue front", error);
        });

      // this.$refs.submitForm.submit();
    }
  }
};
</script>
<style scoped>
.cus-list p {
  position: relative;
}
.owl-carousel .owl-nav .owl-prev,
.owl-carousel .owl-nav .owl-next {
  font-weight: bold;
  font-size: 24px;
  font-family: monospace;
  padding: 10px 20px;
}

.owl-carousel .owl-nav .owl-prev {
  color: blue;
}
.owl-carousel .owl-nav .owl-prev:hover {
  color: aqua;
}

.owl-carousel .owl-nav .owl-next {
  color: red;
}
.owl-carousel .owl-nav .owl-next:hover {
  color: yellow;
}
.cus-list p .selected-items {
  float: right;
  font-size: 14px;
  font-weight: bold;
  color: #e78785;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.cus-list .fbCat::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.cus-list .fbCat li {
  margin-right: 1.8rem;
  font-size: 14px;
  color: #810c13;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  text-transform: uppercase;
}

.cus-list .fbCat li:hover,
.cus-list .fbCat li.active {
  color: #000000;
}

.cus-list .fbCat li.active::after {
  left: 0;
  right: 0;
  content: "";
  z-index: 9;
  width: 15px;
  height: 15px;
  bottom: -25px;
  margin: 0 auto;
  position: absolute;
  border-color: #000;
  border-style: dotted;
  background: #bc112b;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  border-width: 0px 1.4px 1.4px 0px;
}

.counter-box {
  /* border: 1px solid #000; */
  border-radius: 15px;
}

.counter-box .decrease {
  font-size: 12px;
  height: 20px;
  width: 20px;
  outline: 0;
  box-shadow: none;
  border: none;
  cursor: pointer;
  color: #000;
  font-weight: bolder;
  background-color: #cc202e;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  border-right: 0.5px solid #000;
}

.counter-box .output {
  width: 20px;
  display: flex;
  font-size: 10px;
  color: #000;
  font-weight: bold;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}

.counter-box .increase {
  height: 20px;
  width: 20px;
  outline: 0;
  border: none;
  font-size: 12px;
  cursor: pointer;
  color: #000000;
  box-shadow: none;
  font-weight: bolder;
  background-color: #87c03f;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  border-left: 0.5px solid #000000;
}

.fbDetails {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 15px 15px 15px;
  justify-content: space-between;
}

.red-fb-box {
  border: 1px dotted #fff;
  padding: 10px;
  border-radius: 10px;
}

.red-fb-box img {
  word-break: break-word;
}

.foodBevrage .fb-name {
  margin-bottom: 0;
  font-size: 18px;
  color: #000000;
  /* text-transform: uppercase; */
  word-break: break-word;
}

.foodBevrage .fb-desc {
  margin-bottom: 0;
  font-size: 14px;
  color: #000000;
  /* text-transform: uppercase; */
  word-break: break-word;
}

.foodBevrage .fb-price {
  font-size: 14px;
  color: #000000;
  text-transform: uppercase;
}
.foodBevrage .sub-box:last-child {
  margin-bottom: 80px !important;
}
.foodBevrage .fb-name {
  font-size: 12px;
}
.foodBevrage .fb-price {
  font-size: 12px;
}
.fbDetails {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 15px 15px 15px;
  justify-content: space-between;
}

.premiere-fb-box {
  border: 1px dotted #b71f1f;
  padding: 10px;
  border-radius: 10px;
}

.foodBevrage .fb-name {
  margin-bottom: 0;
  font-size: 18px;
  color: #000000;
  /* text-transform: uppercase; */
}

.foodBevrage .fb-price {
  font-size: 14px;
  color: #000000;
  text-transform: uppercase;
}

.seat-list,
.lang-list,
.food-list,
.genre-list,
.prefCinema-list {
  cursor: default;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.food-list li {
  display: inline-flex;
}

.food-list li span {
  font-weight: normal;
}

.food-list li::after {
  content: "\2022";
  margin-left: 5px;
  margin-right: 5px;
}
</style>
<style scoped>
input[type="checkbox"] {
  height: 16px;
  position: relative;
  /* margin-right: 12px; */
}

footer {
  display: none;
}
.pointer-none {
  pointer-events: none;
}

.modal-bg {
  width: 100%;
  position: fixed;
  z-index: 100000;
  margin: 0 0 auto auto;
  background: #00000078;
  padding: 100px 0 0 0;
  height: 100%;
}

div.b {
  white-space: nowrap;
  /* width: 150px; */
  overflow: hidden;
  /* background: red; */
  height: 20px;
  text-overflow: ellipsis;
}

.pointer-none {
  pointer-events: none;
}

.tnc {
  list-style: decimal;
  padding-left: 12px;
}
.rtl .tnc li {
  text-align: right;
}
.fnb-info {
  min-height: 150px;
}
.tooltip {
  max-width: 300px;
  width: 300px;
}
.tooltip-inner {
  max-width: 300px !important;
  width: 300px !important;
}
.number_reverse {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  flex-wrap: wrap;
}
.sbtr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-evenly;
}
@media (max-width: 768px) {
  .sbtr {
    /* justify-content: space-between; */
  }
}
.screen-text {
  position: absolute;
  top: 0px;
  /* right: 67%; */
  width: 100%;
}
.screen-img {
  width: 100%;
  height: 100%;
}
.big-seat {
  width: 50px !important;
  height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/SNcheckout.vue